/* eslint-disable complexity */
/* eslint-disable no-nested-ternary */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable max-lines */
/* eslint-disable max-statements */
/* eslint-disable extra-rules/no-commented-out-code */
// 9fbef606107a605d69c0edbcd8029e5d
import cloneDeep from 'lodash/cloneDeep';
import {
  setLoaderState,
  setSectionLoaderState,
} from '@tcp/core/src/components/common/molecules/Loader/container/Loader.actions';
import { updateRecommendationsLoading } from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.actions';
import CacheConfiguration from '@tcp/core/src/services/handler/graphQL/clients/retryConfiguration';
import { BRAND_NAMES } from '@tcp/core/src/constants/pageTitle.constants';
import { setLocalStorage, getLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import {
  getLoyaltyDetail,
  simulateLoyaltyDetail,
} from '@tcp/core/src/components/features/CnC/LoyaltyBanner/container/Loyalty.actions';
import InjectLoyaltyDynamicStore from '@tcp/core/src/components/features/CnC/LoyaltyBanner/container/LoyaltyDynamicStore';
import {
  getCartCacheTTL,
  getFlipSwitchState,
  getUnbxdDRUrlState,
  getIsPersistPointsApiEnabled,
  estimatedTaxReduxTTL,
  getIsAccessoryEnabled,
  getMakeInventoryCallAsync,
  getIsKillItemCountCompare,
  getIsBOSSswitchEnabled,
  getABTestIsBOSSswitchEnabled,
  getBossUnavailableSwitch,
  getSetShippingTotalInCache,
  getIsApplyCheckboxPromoOnPDPEnabled,
  getIsOTpScreenEnabled,
  getSuppressCvvField,
  getIsLoyaltyTieringEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';

import { getPreferredAddress } from '@tcp/core/src/components/features/account/AddressBook/container/AddressBook.selectors';
import { checkIf0007Present } from '@tcp/core/src/components/common/molecules/Accessories/util/utility';
import AddedtoBagDynamicStore from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBagDynamicStore';
import { getIsGuest } from '@tcp/core/src/components/features/account/User/container/User.selectors.js';
import { loyaltyCouponUpdateBPD } from '@tcp/core/src/components/features/CnC/common/organism/CouponAndPromos/container/Coupon.saga.js';
import { List } from 'immutable';
import {
  all,
  call,
  delay,
  put,
  select,
  takeLatest,
  fork,
  take,
  actionChannel,
} from 'redux-saga/effects';
import { setBenefits } from '@tcp/core/src/components/features/CnC/common/organism/CouponAndPromos/container/Coupon.actions.js';
import { getExpressCheckoutData } from '@tcp/core/src/services/abstractors/CnC/CheckoutSFCC';
import { NavigateXHR } from '@tcp/core/src/services/abstractors/account/NavigateXHR';
import {
  capitalize,
  getAPIConfig,
  getTranslateDateInformation,
  setSessionStorage,
  setValueInAsyncStorage,
  urlContainsQuery,
  getSessionStorage,
  removeSessionStorage,
  getSiteId,
  getBrand,
} from '@tcp/core/src/utils';
import logger from '@tcp/core/src/utils/loggerInstance';
import { getDynamicLabelValues } from '@tcp/core/src/utils/labels/labelUtilty';
import injectCouponDynamicStore from '@tcp/core/src/components/features/CnC/common/organism/CouponAndPromos/container/CouponDynamicStore';
import { fromAvailableStoresClickReset } from '@tcp/core/src/components/common/organisms/ProductPickup/container/ProductPickup.actions';
import { getShowVerificationError } from '@tcp/core/src/components/features/account/CreateAccount/container/CreateAccount.selectors';
import {
  getCurrentSiteLanguage,
  getIsInternationalShipping,
  getIsRadialInventoryEnabled,
  getRecalcOrderPointsInterval,
  multiDeviceEnabled,
  newMsEstimatedTax,
} from '../../../../../reduxStore/selectors/session.selectors';
import {
  getServerErrorMessage,
  fetchEstimatedTax,
} from '../../../../../services/abstractors/CnC/Checkout';
import BAG_SELECTORS, {
  getCartModuleXList,
  getECOMStatus,
  getOrderType,
  getEstimatedTaxFromDefaultShipping,
  isFromEstimatedTaxFormFlag,
  isPersistEddCartPageEnabled,
  isPersistEddGlobalEnabled,
} from './BagPage.selectors';
import {
  getOrderDetailsData,
  getProductInfoForTranslationData,
} from '../../../../../services/abstractors/CnC/CartItemTile';
import { CONTACT_FORM } from '../../SinglePageCheckout/molecules/ContactForm/ContactForm.constant';

import BAG_PAGE_ACTIONS, {
  updateMiniBagFlag,
  setAddedToBagDataLocal,
  setBagLoadingStatus,
  setSflId,
  resetTaxFromDefaultAddress,
  setSubmitButtonState,
  nonCachedDataLoading,
  fetchInventoryDetails,
  setApplePayDefault,
  saveShareCartErr,
  fetchShareCartErr,
  togglePlccLoginModal,
  hasSFLApiCallCompleted,
} from './BagPage.actions';
import CHECKOUT_ACTIONS, {
  checkoutSetCartData,
  getSetIsPaypalPaymentSettings,
  toggleCheckoutRouting,
  setVenmoPaymentInProgress,
  setApplePaymentInProgress,
  setAfterPayInProgress,
  getSetPickupValuesActn,
  getSetPickupAltValuesActn,
  updateCartShipmentMethod,
  submitReviewSection,
  setAfterPayPaymentProgress,
} from '../../Checkout/container/Checkout.action';
import { getModuleX } from '../../../../../services/abstractors/common/moduleXComposite';
import {
  getUserLoggedInState,
  getIsRegisteredUserCallDone,
  getSFLId,
  getUserEmail,
} from '../../../account/User/container/User.selectors';
import {
  emailSubmit,
  setCheckoutModalMountedState,
  setPlccLoginLoadingState,
} from '../../../account/LoginPage/container/LoginPage.actions';
import checkoutSelectors, {
  isRemembered,
  isExpressCheckout,
  getLoginV2FlowEnabled,
} from '../../Checkout/container/Checkout.selector';
import { isCanada, routerPush, readCookie, getBasketId } from '../../../../../utils';

import {
  addItemToSflList,
  getSflItems,
  updateSflItem,
} from '../../../../../services/abstractors/CnC/SaveForLater';
import {
  removeCartItem,
  setApplePayCartLoadingState,
  setCartLoadingState,
  setCheckoutInProgress,
} from '../../CartItemTile/container/CartItemTile.actions';
import {
  getCartOrderId,
  getIsBackPackAloneError,
} from '../../CartItemTile/container/CartItemTile.selectors';
/* eslint-disable import/no-cycle */
import { removeCartItem as removeCartItemSaga } from '../../CartItemTile/container/CartItemTileCommon.saga';
import {
  getCartCachedData as fetchCartCachedData,
  getCartNonCachedData as fetchCartNonCachedData,
  getCurrentOrderFormatter,
  getGifCardDetailsFormatter,
  getOrderBillingFormatter,
  getOrderCouponFormatter,
  getOrderGiftWrapFormatter,
  getOrderItemFormatter,
  getOrderLoyaltyFormatter,
  getOrderShippingFormatter,
  getOrderSummaryFormatter,
  fetchBasketInventoryDetails,
  getUnqualifiedItems,
  startPaypalCheckoutAPI,
  paypalAuthorizationAPI,
  removeItem,
  imageGenerator,
  getCartCachedDataApplePay,
} from '../../../../../services/abstractors/SFCC/CartItemTile';
import { saveShareCart, fetchShareCart } from '../../../../../services/abstractors/SFCC/shareCart';
import {
  closeMiniBag,
  updateCartManually,
} from '../../../../common/organisms/Header/container/Header.actions';
import { getUserInfoSaga } from '../../../account/User/container/User.saga';
// eslint-disable-next-line import/no-cycle
import CONSTANTS, {
  CHECKOUT_ROUTES,
  DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY,
  ORDER_TYPE,
  RECALCULATE_CACHE,
} from '../../Checkout/Checkout.constants';
// eslint-disable-next-line
import {
  getRouteToCheckoutStage,
  handleServerSideErrorAPI,
} from '../../Checkout/container/CheckoutCommon.saga';
import utility from '../../Checkout/util/utility';
import {
  getCouponList,
  clearCouponTTL,
} from '../../common/organism/CouponAndPromos/container/Coupon.actions';
import {
  recalibrateSectionStates,
  setSpcButtonLoader,
  setSFSErrors,
  isExpressUserCallDone,
  isNonCachedCartDataCallDone,
  setSuppressCCheck,
} from '../../SinglePageCheckout/container/SinglePageCheckout.actions';
import SpcSelector, {
  getSfsError,
} from '../../SinglePageCheckout/container/SinglePageCheckout.selector';
import BAGPAGE_CONSTANTS from '../BagPage.constants';
import startSflItemDelete from './BagPage.saga.util';
import CARTITEMTILE_CONSTANTS from '../../CartItemTile/CartItemTile.constants';
import {
  validateReduxCache,
  calculateReduxCachedCartTTL,
  deleteCache,
  deleteTtlCache,
  validateCache,
} from '../../../../../utils/cache.util';
import { callPersistData } from '../../SinglePageCheckout/container/SinglePageCheckout.saga.util';
import { SPC_BUTTON } from '../../SinglePageCheckout/container/SinglePageCheckout.constants';
import { addToCartEcom } from '../../AddedToBag/container/AddedToBag.actions';
import { parseStoreOpeningAndClosingTimesSFCC } from '../../../../../utils/parseStoreHours';
import LoginPageDynamicStore from '../../../account/LoginPage/container/LoginPageDynamicStore';
import updateOrderDetailsWithoutCheck from './UpdateOrderDetails';
import { AVAILABILITY } from '../../../browse/Favorites/container/Favorites.constants';
import { resetBossUnavailableState } from '../../CartItemTile/molecules/BossUnavailableTile/container/BossUnavailable.actions';
import { getBossUnavailableProduct } from '../../CartItemTile/molecules/BossUnavailableTile/container/BossUnavailable.selector';
import { getShippingTotal } from '../../common/organism/OrderLedger/container/orderLedger.selector';
import { getEarliestPromoStartDateEndDate } from '../../../../common/organisms/Promotions/utils/util';
import { setPointsToRedeem } from '../../common/organism/LoyaltyRewards/container/LoyaltyRewards.actions';

const { ORDER_ITEM_TYPE } = CONSTANTS;
const { getOrderPointsRecalcFlag } = utility;
let isCartSyncTrigerred = false;

export const filterProductsBrand = (arr, searchedValue) => {
  const obj = [];
  const filterArray = arr.filter((value) => {
    return value.productInfo.itemBrand === searchedValue;
  });
  filterArray.forEach((item) => {
    obj.push(item.productInfo.productPartNumber);
  });
  return obj;
};

const getProductsTypes = (orderItems) => {
  let tcpProducts = [];
  let gymProducts = [];
  let snjProducts = [];
  if (orderItems) {
    tcpProducts = filterProductsBrand(orderItems, 'TCP');
    gymProducts = filterProductsBrand(orderItems, 'GYM');
    snjProducts = filterProductsBrand(orderItems, 'SNJ');
  }
  return { tcpProducts, gymProducts, snjProducts };
};

export function* getUnbxdXappConfigs() {
  const isFlipURL = yield select(getFlipSwitchState);
  const drURLpath = yield select(getUnbxdDRUrlState);
  return {
    isFlipURL,
    drURLpath,
  };
}

export function* getProductResults(prodTypes) {
  const xappURLConfig = yield call(getUnbxdXappConfigs);
  const { gymProducts, tcpProducts, snjProducts } = prodTypes;
  const productResult = {};

  if (tcpProducts.length) {
    productResult.tcpProductsResults = yield call(
      getProductInfoForTranslationData,
      tcpProducts.join(),
      'TCP',
      xappURLConfig
    );
  }
  if (gymProducts.length) {
    productResult.gymProductsResults = yield call(
      getProductInfoForTranslationData,
      gymProducts.join(),
      'GYM',
      xappURLConfig
    );
  }
  if (snjProducts.length) {
    productResult.snjProductsResults = yield call(
      getProductInfoForTranslationData,
      snjProducts.join(),
      'SNJ',
      xappURLConfig
    );
  }
  return productResult;
}
export function* getTranslatedProductInfo(cartInfo) {
  try {
    const productTypes = getProductsTypes(
      (cartInfo.orderDetails && cartInfo.orderDetails.orderItems) || cartInfo
    );
    const productResults = yield call(getProductResults, productTypes);
    let { gymProductsResults, tcpProductsResults, snjProductsResults } = productResults;
    gymProductsResults = (gymProductsResults && gymProductsResults.body.response.products) || [];
    tcpProductsResults = (tcpProductsResults && tcpProductsResults.body.response.products) || [];
    snjProductsResults = (snjProductsResults && snjProductsResults.body.response.products) || [];

    return [...gymProductsResults, ...tcpProductsResults, ...snjProductsResults];
  } catch (err) {
    return [];
  }
}

function fetchVariantDetails(orderItem, variants) {
  const productItem = orderItem;
  const isCASite = isCanada();
  variants.forEach((variant) => {
    if (orderItem.productInfo.variantNo === variant.variantId) {
      productItem.productInfo.name = variant.product_name;
      productItem.productInfo.color.name = variant.auxdescription || variant.TCPColor;
      productItem.productInfo.size = variant.v_tcpsize && variant.v_tcpsize.split('_')[1];
      productItem.productInfo.fit = variant.v_tcpfit;
      productItem.productInfo.tcpStyleQty = !isCASite
        ? variant.TCPStyleQTYUS
        : variant.TCPStyleQTYCA;
      productItem.productInfo.tcpStyleType = !isCASite
        ? variant.TCPStyleTypeUS
        : variant.TCPStyleTypeCA;
      productItem.miscInfo.clearanceItem = !isCASite
        ? variant.TCPProductIndUSStore === 'Clearance'
        : variant.TCPProductIndCanadaStore === 'Clearance';
      productItem.miscInfo.isOnlineOnly = !isCASite
        ? Boolean(parseInt(variant.TCPWebOnlyFlagUSStore, 10))
        : Boolean(parseInt(variant.TCPWebOnlyFlagCanadaStore, 10));
    }
  });
}

function createMatchObject(res, translatedProductInfo) {
  res.forEach((orderItemInfo) => {
    const orderItem = orderItemInfo;
    translatedProductInfo.forEach((item) => {
      if (orderItem.productInfo.productPartNumber === item.prodpartno) {
        fetchVariantDetails(orderItem, item.variants);
      }
    });
  });
}

export function* shouldTranslate(translation) {
  const currentLanguage = yield select(getCurrentSiteLanguage);
  const allowLanguageTranslation = currentLanguage !== 'en';
  return translation && allowLanguageTranslation;
}

export function* getOrderDetailSaga(payload) {
  const { payload: { after, recalcRewards = false, isRecalc } = {} } = payload;
  try {
    yield put(updateCartManually(true));
    yield put(BAG_PAGE_ACTIONS.setBagPageLoading());
    const isOptimiseAddProductOrderDetailsEnabled = yield select(
      BAG_SELECTORS.getOptimiseAddProductOrderDetailsEnabled
    );
    const isECOM = yield select(getECOMStatus);
    const isCalc = isECOM ? isRecalc : !isOptimiseAddProductOrderDetailsEnabled;
    const isRadialInvEnabled = yield select(getIsRadialInventoryEnabled);
    const recalcOrderPointsInterval = yield select(getRecalcOrderPointsInterval);
    const isRecalcRewards = getOrderPointsRecalcFlag(
      recalcRewards,
      recalcOrderPointsInterval,
      RECALCULATE_CACHE.ORDER_DETAILS
    );
    const res = yield call(getOrderDetailsData, isCalc, isRadialInvEnabled, isRecalcRewards);
    yield put(BAG_PAGE_ACTIONS.updatePayPalStatus(res));
    if (yield call(shouldTranslate, true)) {
      const translatedProductInfo = yield call(getTranslatedProductInfo, res);
      if (!translatedProductInfo.error) {
        createMatchObject(res.orderDetails.orderItems, translatedProductInfo);
      }
    }
    yield put(BAG_PAGE_ACTIONS.getOrderDetailsComplete(res.orderDetails));
    const isLoyaltyPointsEnabled = yield select(getIsPersistPointsApiEnabled);

    // Call Loyalty Points API when Brierley service is down And Get flag 'loyaltyCallEnabled' from cart Api
    if (isLoyaltyPointsEnabled) {
      yield put(
        getLoyaltyDetail({
          ...res.orderDetails.loyaltyPointsRequestPayload,
          source: 'Cart',
          pointsApiCall: res.orderDetails.pointsApi,
        })
      );
    }
    yield put(toggleCheckoutRouting(true));
    if (after) {
      yield call(after);
    }
  } catch (err) {
    yield put(BAG_PAGE_ACTIONS.setBagPageError(err));
  }
}

export function* setBagPageLoading(fromMoveTobag, ignoreCartLoader, skipCache = false) {
  if (!skipCache && !fromMoveTobag && !ignoreCartLoader) {
    yield put(BAG_PAGE_ACTIONS.setBagPageLoading());
  }
}

export function* handelAddressIds(orderDetails, addressIds) {
  if (orderDetails && orderDetails.checkout && orderDetails.checkout.shipping) {
    const onFileAddressId = orderDetails?.checkout?.shipping?.address?.id || '';
    const updatedIds = { ...addressIds };
    if (addressIds?.previousId === '' && addressIds?.currentId !== '') {
      updatedIds.previousId = '';
      updatedIds.currentId = onFileAddressId;
      yield put(BAG_PAGE_ACTIONS.updateAddressIds(updatedIds));
    } else if (addressIds.currentId !== onFileAddressId) {
      updatedIds.previousId = addressIds.currentId;
      updatedIds.currentId = onFileAddressId;
      yield put(BAG_PAGE_ACTIONS.updateAddressIds(updatedIds));
    }
  }
}

function isBagPackCall(catEntryId, orderAccessorieItems, orderItemsCartPage) {
  let itemId = '';
  let isThisBackPackCall = false;
  const orderAccessorieItemsParsed =
    orderAccessorieItems && JSON.parse(JSON.stringify(orderAccessorieItems));
  const orderItems = orderItemsCartPage && JSON.parse(JSON.stringify(orderItemsCartPage));

  if (catEntryId && Array.isArray(catEntryId)) {
    itemId = catEntryId[0].catEntryId;
  } else {
    itemId = catEntryId;
  }
  if (orderAccessorieItemsParsed && orderAccessorieItemsParsed[itemId]) {
    const is0007Present = checkIf0007Present(itemId, orderAccessorieItemsParsed);
    orderItems.forEach((item) => {
      // TODO if we have to check if only 0007 acc is present. Take payload from CartItemNewtile.
      if (
        item?.productInfo?.generalProductId === itemId &&
        ((item?.miscInfo?.c_accessories && item?.miscInfo?.c_accessories.length > 0) ||
          item?.miscInfo?.c_mainProducts ||
          is0007Present)
      ) {
        isThisBackPackCall = true;
      }
    });
  }
  return isThisBackPackCall;
}

// function getExcludeCartItems(excludeCartItems, cartTotalCount, rawCartItems = []) {
//   const totalCount = Array.isArray(rawCartItems)
//     ? rawCartItems.reduce((count, item) => {
//         return item && item.qty ? item.qty + count : count;
//       }, 0)
//     : 0;
//   return excludeCartItems && cartTotalCount === totalCount;
// }

const getOrderTypes = (items) => {
  let obj = {};
  if (items) {
    let isBossOrder = items.find(
      (store) => store?.miscInfo.orderItemType?.toUpperCase() === ORDER_ITEM_TYPE.BOSS
    );

    let isBopisOrder = items.find(
      (store) => store?.miscInfo.orderItemType?.toUpperCase() === ORDER_ITEM_TYPE.BOPIS
    );
    let isECOM = items.find((store) => store?.miscInfo.orderItemType?.toUpperCase() === 'ECOM');

    isBopisOrder = !!isBopisOrder;
    isBossOrder = !!isBossOrder;
    isECOM = !!isECOM;
    const isPickupOrder = isBopisOrder || isBossOrder;
    let orderType = '';
    if (isECOM && !isBopisOrder && !isBossOrder) {
      // Pure ECOM
      orderType = ORDER_TYPE.PURE_ECOM;
    } else if (isBopisOrder && !isECOM && !isBossOrder) {
      // Pure BopisOrder
      orderType = ORDER_TYPE.PURE_BOPIS;
    } else if (isBossOrder && !isECOM && !isBopisOrder) {
      // Pure BOSS
      orderType = ORDER_TYPE.PURE_BOSS;
    } else if (isECOM && (isBossOrder || isBopisOrder)) {
      orderType = ORDER_TYPE.ECOM_MIX;
    } else if (isBossOrder && isBopisOrder && !isECOM) {
      orderType = ORDER_TYPE.BOSS_AND_BOPIS;
    }
    obj = {
      isBopisOrder,
      isBossOrder,
      isECOM,
      isPickupOrder,
      orderType,
    };
  }
  return obj;
};

const altNames = (value, nameFlag) => {
  if (value) {
    const names = value?.split(' ');
    return names[nameFlag];
  }
  return '';
};

const getPickUpContact = (storeDetails) => {
  return {
    firstName:
      storeDetails?.shippingAddress?.firstName === DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.firstName
        ? ''
        : storeDetails?.shippingAddress?.firstName || '',
    lastName:
      storeDetails?.shippingAddress?.lastName === DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.lastName
        ? ''
        : storeDetails?.shippingAddress?.lastName || '',
    emailAddress:
      storeDetails?.shippingAddress?.c_emailAddress === DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.email
        ? ''
        : storeDetails?.shippingAddress?.c_emailAddress || '',
    phoneNumber:
      storeDetails?.shippingAddress?.phone === DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.phone
        ? ''
        : storeDetails?.shippingAddress?.phone || '',
    phoneCountryCode: storeDetails?.shippingAddress?.c_phoneCountryCode || '',
  };
};

const getPickUpDetails = (shipments) => {
  if (shipments) {
    const storeDetails = shipments.filter((shipment) => shipment.shipmentId !== 'me')[0];
    if (storeDetails) {
      const pickUpContact = getPickUpContact(storeDetails);

      const pickUpAlternative = {
        lastName: altNames(storeDetails?.shippingAddress?.c_altName, 1) || '',
        firstName: altNames(storeDetails?.shippingAddress?.c_altName, 0) || '',
        emailAddress: storeDetails?.shippingAddress?.c_altEmail || '',
      };

      return { pickUpContact, pickUpAlternative };
    }
    return {};
  }
  return {};
};

export const formatCachedResponse = (resp, addToBagResponse = {}) => {
  const respToProcess = resp || {};
  const { totalItems, orderItems, orderAccessorieItems } = getOrderItemFormatter(respToProcess);
  const { shipmentId: shipModeId, shipping } = getOrderShippingFormatter(addToBagResponse);
  const loyalty = getOrderLoyaltyFormatter(respToProcess);
  const rest = getOrderSummaryFormatter(respToProcess);
  const giftWrap = getOrderGiftWrapFormatter(respToProcess);
  const finalData = {
    orderDetails: {
      totalItems,
      orderItems,
      orderAccessorieItems,
      loyaltyPointsRequestPayload: { ...loyalty },
      checkout: {
        ...giftWrap,
      },
      ...rest,
      ...getOrderTypes(orderItems),
      ...getOrderCouponFormatter(respToProcess),
    },
  };
  if (addToBagResponse?.shipments?.length) {
    finalData.orderDetails.shipments = addToBagResponse?.shipments;
    finalData.orderDetails.shipModeId = shipModeId;
    finalData.orderDetails.checkout.shipping = shipping;
  }
  return cloneDeep(finalData);
};

export const formatNonCachedResponse = (resp) => {
  const respToProcess = resp || {};
  const { shipmentId: shipModeId, shipping } = getOrderShippingFormatter(respToProcess);
  const billing = getOrderBillingFormatter(respToProcess);
  const coupon = getOrderCouponFormatter(respToProcess);
  const giftWrap = getOrderGiftWrapFormatter(respToProcess);
  const rest = getOrderSummaryFormatter(respToProcess);
  const { giftCardDetails, appliedGiftCards, giftCardsTotal } =
    getGifCardDetailsFormatter(respToProcess);
  const { pickUpContact, pickUpAlternative } = getPickUpDetails(respToProcess?.shipments);

  const defaultCheckout = {
    pickUpContact,
    pickUpAlternative,
    shipping: {},
    billing: {},
  };
  const checkout = {
    ...defaultCheckout,
    ...giftWrap,
    shipping,
    billing,
  };

  const finalData = {
    orderDetails: {
      shipModeId,
      checkout,
      ...coupon,
      ...rest,
      giftCardDetails,
      appliedGiftCards,
      giftCardsTotal,
    },
  };
  return cloneDeep(finalData);
};
function getInventoryConst(inventoryItem, orderItemType) {
  const isCanadaSite = isCanada();
  const {
    styleTypeUS,
    styleTypeCA,
    styleQtyUS,
    styleQtyCA,
    productIndUSStore,
    productIndCanadaStore,
    webOnlyFlagUSStore,
    webOnlyFlagCanadaStore,
    availableQty: qty,
    requestedQty,
    bossAvailableQty,
    bopisInventory,
    online,
    isHardMarkEnabled,
    availableOffers,
    isPackAndHold,
    storeSpecials,
    promoMessage,
    shippingRestrictedStates,
    c_TCPBigIdeaLicensedProductBrand: tcpBigIdeaLicensedProductBrand,
    appliedOffers,
    earlyAccessAvailability,
  } = inventoryItem;
  let availableQty = qty;
  if (orderItemType.toUpperCase() === ORDER_ITEM_TYPE.BOSS) {
    availableQty = bossAvailableQty || 0;
  }
  if (orderItemType.toUpperCase() === ORDER_ITEM_TYPE.BOPIS && bopisInventory?.atcQuantity) {
    const { atcQuantity } = bopisInventory;
    availableQty = atcQuantity; // will remove qty once received atcQuantity from Inventory API. Added condtion for null to avoid undefined as availableQty
  }

  const tcpStyleType = !isCanadaSite ? styleTypeUS : styleTypeCA;
  const tcpStyleQty = !isCanadaSite ? styleQtyUS : styleQtyCA;
  const clearanceItem = !isCanadaSite
    ? productIndUSStore === 'Clearance'
    : productIndCanadaStore === 'Clearance';
  const isOnlineOnly = !isCanadaSite
    ? Boolean(parseInt(webOnlyFlagUSStore, 10))
    : Boolean(parseInt(webOnlyFlagCanadaStore, 10));
  const availability =
    availableQty - requestedQty >= 0
      ? CARTITEMTILE_CONSTANTS.AVAILABILITY.OK
      : CARTITEMTILE_CONSTANTS.AVAILABILITY.UNAVAILABLE;
  const isProductOnline = online;
  const availabilitySTH =
    qty - requestedQty >= 0
      ? CARTITEMTILE_CONSTANTS.AVAILABILITY.OK
      : CARTITEMTILE_CONSTANTS.AVAILABILITY.UNAVAILABLE;
  return {
    tcpStyleType,
    tcpStyleQty,
    clearanceItem,
    isOnlineOnly,
    availability,
    availableQty,
    isProductOnline,
    isHardMarkEnabled,
    availabilitySTH,
    promoMessage,
    availableOffers,
    appliedOffers,
    isPackAndHold,
    storeSpecials,
    shippingRestrictedStates,
    tcpBigIdeaLicensedProductBrand,
    earlyAccessAvailability,
  };
}
const getStoredProductDetails = (storeObj) => {
  const { language } = getAPIConfig();
  const {
    name,
    cIsStoreBossEligible,
    address1,
    address2,
    city,
    stateCode,
    postalCode,
    phone,
    bossMinDate,
    bossMaxDate,
    storeHours,
  } = storeObj;
  const { todayOpeningTime, todayClosingTime, tomorrowOpeningTime, tomorrowClosingTime } =
    parseStoreOpeningAndClosingTimesSFCC(storeHours);
  const finalData = {
    store: name ? capitalize(name) : null,
    isStoreBOSSEligible: !!cIsStoreBossEligible,
    storeAddress: address1
      ? {
          addressLine1: capitalize(address1),
          addressLine2: address2,
          city: capitalize(city),
          state: stateCode,
          zipCode: postalCode?.trim(),
        }
      : null,
    storePhoneNumber: (phone || '').trim(),
    storeTodayOpenRange: storeHours ? `${todayOpeningTime} -  ${todayClosingTime}` : null,
    storeTomorrowOpenRange: storeHours ? `${tomorrowOpeningTime} - ${tomorrowClosingTime}` : null,
    storeHours,
    // dates for boss pickup, used getDateInformation utility
    // shows number of items from the store
    storeItemsCount: 0,
  };
  if (bossMaxDate) {
    finalData.bossStartDate = bossMinDate && getTranslateDateInformation(bossMinDate, language);
  }
  if (bossMinDate) {
    finalData.bossEndDate = bossMaxDate && getTranslateDateInformation(bossMaxDate, language);
  }
  return finalData;
};

const getVariantVisePreOrder = (variantPreOrderDates, variantIdForPreOrder, variantSize) => {
  const preOrderDates = variantPreOrderDates?.split('|');
  let variantVisePreOrder = preOrderDates?.find((variantDate) => {
    const variantId = variantDate?.split('#')[0];
    return variantId === variantIdForPreOrder;
  });
  if (variantVisePreOrder) {
    variantVisePreOrder = variantVisePreOrder?.split('#');
    return {
      variant: variantIdForPreOrder,
      preOrderDate: variantVisePreOrder[1],
      size: variantSize,
    };
  }
  return {};
};

function extCheckDifference(orderItem, inventoryItem) {
  const item = orderItem;
  const {
    productName,
    size,
    color,
    fit,
    listPrice: wasPrice,
    tcpPreOrderDateUSStore: preOrderDate,
    variantPreOrderDateUS,
    variantPreOrderDateCA,
    productId,
  } = inventoryItem;
  const newVariantPreOrderMap = isCanada()
    ? getVariantVisePreOrder(variantPreOrderDateCA, productId, size)
    : getVariantVisePreOrder(variantPreOrderDateUS, productId, size);
  const itemLevelPreOrderDate = item?.itemInfo?.preOrderDate;
  let isDifferent = false;
  if (productName && item.productInfo.name !== productName) {
    isDifferent = true;
    item.productInfo.name = productName;
  }
  if (size && item.productInfo.size !== size) {
    isDifferent = true;
    item.productInfo.size = size;
  }
  if (color && item.productInfo.color && item.productInfo.color.name !== color) {
    isDifferent = true;
    item.productInfo.color.name = color;
  }
  if (fit && item.productInfo.fit !== fit?.toLowerCase()) {
    isDifferent = true;
    item.productInfo.fit = fit?.toLowerCase(); // Inventory api call returns capitalized while other are in lower case
  }
  if (wasPrice && item.itemInfo.wasPrice !== wasPrice) {
    isDifferent = true;
    item.itemInfo.wasPrice = wasPrice;
  }
  if (
    Object.keys(newVariantPreOrderMap).length &&
    itemLevelPreOrderDate !== newVariantPreOrderMap?.preOrderDate &&
    item.miscInfo.variantPreOrderMap !== newVariantPreOrderMap
  ) {
    isDifferent = true;
    item.miscInfo.variantPreOrderMap = newVariantPreOrderMap;
    item.itemInfo.preOrderDate = newVariantPreOrderMap?.preOrderDate;
  } else if (
    preOrderDate &&
    itemLevelPreOrderDate !== preOrderDate &&
    item.miscInfo.variantPreOrderMap?.preOrderDate !== preOrderDate
  ) {
    isDifferent = true;
    item.miscInfo.variantPreOrderMap = {};
    item.miscInfo.variantPreOrderMap.preOrderDate = preOrderDate;
    item.itemInfo.preOrderDate = preOrderDate;
  }
  return { isDifferent, item };
}
function checkDifference(orderItem, inventoryItem, store) {
  const { miscInfo } = orderItem || {};
  const { orderItemType } = miscInfo || {};
  const {
    tcpStyleType,
    tcpStyleQty,
    clearanceItem,
    isOnlineOnly,
    availability,
    availableQty,
    isProductOnline,
    isHardMarkEnabled,
    availabilitySTH,
    promoMessage,
    availableOffers,
    appliedOffers,
    isPackAndHold,
    storeSpecials,
    shippingRestrictedStates,
    tcpBigIdeaLicensedProductBrand,
    earlyAccessAvailability,
  } = getInventoryConst(inventoryItem, orderItemType);
  let isDifferent = false;
  const { isDifferent: diff, item } = extCheckDifference(orderItem, inventoryItem);
  isDifferent = diff;
  if (item?.miscInfo?.online !== isProductOnline) {
    isDifferent = true;
    item.miscInfo.online = isProductOnline;
  }

  if (tcpStyleType && item.productInfo.tcpStyleType !== tcpStyleType) {
    isDifferent = true;
    item.productInfo.tcpStyleType = tcpStyleType;
  }
  if (tcpStyleQty && item.productInfo.tcpStyleQty !== tcpStyleQty) {
    isDifferent = true;
    item.productInfo.tcpStyleQty = tcpStyleQty;
  }
  if (clearanceItem && item.miscInfo.clearanceItem !== clearanceItem) {
    isDifferent = true;
    item.miscInfo.clearanceItem = clearanceItem;
  }
  if (isOnlineOnly && item.miscInfo.isOnlineOnly !== isOnlineOnly) {
    isDifferent = true;
    item.miscInfo.isOnlineOnly = isOnlineOnly;
  }
  if (availability && item.miscInfo.availability !== availability) {
    isDifferent = true;
    item.miscInfo.availability = availability;
  }
  if (availableQty && item.miscInfo.availableQty !== availableQty) {
    isDifferent = true;
    item.miscInfo.availableQty = availableQty;
  }
  if (promoMessage && item.miscInfo.promoMessage !== promoMessage) {
    isDifferent = true;
    item.miscInfo.promoMessage = promoMessage;
  }
  if (isHardMarkEnabled && item.miscInfo.isHardMarkEnabled !== isHardMarkEnabled) {
    isDifferent = true;
    item.miscInfo.isHardMarkEnabled = isHardMarkEnabled;
  }
  if (
    shippingRestrictedStates &&
    item.miscInfo.shippingRestrictedStates !== shippingRestrictedStates
  ) {
    isDifferent = true;
    item.miscInfo.shippingRestrictedStates = shippingRestrictedStates;
  }
  if (availableOffers && item.miscInfo.availableOffers !== availableOffers) {
    isDifferent = true;
    item.miscInfo.availableOffers = availableOffers;
  }
  if (appliedOffers && item.miscInfo.appliedOffers !== appliedOffers) {
    isDifferent = true;
    item.miscInfo.appliedOffers = appliedOffers;
  }
  if (storeSpecials && item.miscInfo.storeSpecials !== storeSpecials) {
    isDifferent = true;
    item.miscInfo.storeSpecials = storeSpecials;
  }
  if (isPackAndHold && item.miscInfo.isPackAndHold !== isPackAndHold) {
    isDifferent = true;
    item.miscInfo.isPackAndHold = isPackAndHold;
    //  item.miscInfo.availability = AVAILABILITY.SOLDOUT;
    //  item.miscInfo.online = false;
  }
  if (store) {
    isDifferent = true;
    item.miscInfo = { ...item.miscInfo, ...getStoredProductDetails(store) };
  }
  if (availabilitySTH && item.miscInfo.availabilitySTH !== availabilitySTH) {
    isDifferent = true;
    item.miscInfo.availabilitySTH = availabilitySTH;
  }
  if (
    tcpBigIdeaLicensedProductBrand &&
    item.miscInfo.tcpBigIdeaLicensedProductBrand !== tcpBigIdeaLicensedProductBrand
  ) {
    isDifferent = true;
    item.miscInfo.tcpBigIdeaLicensedProductBrand = tcpBigIdeaLicensedProductBrand;
  }
  if (
    earlyAccessAvailability &&
    item.miscInfo.earlyAccessAvailability !== earlyAccessAvailability
  ) {
    isDifferent = true;
    item.miscInfo.earlyAccessAvailability = earlyAccessAvailability;
  }
  return { isDifferent, item };
}
// Updating loyalty payload from inventory api for multiplier attributes
function checkLoyaltyPayloadDifference(loyaltyItem, inventoryItem) {
  const item = loyaltyItem;
  const {
    loyaltyPromoMultiplierCAStore,
    loyaltyPromoMultiplierUSStore,
    loyaltyPromoPLCCMultiplierCAStore,
    loyaltyPromoPLCCMultiplierUSStore,
  } = inventoryItem;

  let LoyaltyPromoMultiplierStore = loyaltyPromoMultiplierUSStore;
  let LoyaltyPromoPLCCMultiplierStore = loyaltyPromoPLCCMultiplierUSStore;
  if (isCanada()) {
    LoyaltyPromoMultiplierStore = loyaltyPromoMultiplierCAStore;
    LoyaltyPromoPLCCMultiplierStore = loyaltyPromoPLCCMultiplierCAStore;
  }
  let isDifferent = false;
  if (
    LoyaltyPromoMultiplierStore &&
    item.LoyaltyPromoMultiplierStore !== LoyaltyPromoMultiplierStore
  ) {
    isDifferent = true;
    item.LoyaltyPromoMultiplierStore = LoyaltyPromoMultiplierStore;
  }
  if (
    LoyaltyPromoPLCCMultiplierStore &&
    item.LoyaltyPromoPLCCMultiplierStore !== LoyaltyPromoPLCCMultiplierStore
  ) {
    isDifferent = true;
    item.LoyaltyPromoPLCCMultiplierStore = LoyaltyPromoPLCCMultiplierStore;
  }
  return { isDifferent, item };
}
/**
 *
 * @method updateLoyaltyPayload
 * @description this method will update loyalty payload for multiplier from inventory api resp.
 * @param {*} payload loyaltyPayload
 * @param {*} inventory inventory array
 * @returns
 */
const updateLoyaltyPayload = (payload, inventory) => {
  let loyaltyUpdateRequired = false;
  const { loyaltyOrderItems } = payload;
  if (loyaltyOrderItems && loyaltyOrderItems.length) {
    loyaltyOrderItems.forEach((order) => {
      const itemInventory = inventory.find((itm) => itm.productId === order.productId) || {};
      const { isDifferent, item } = checkLoyaltyPayloadDifference(order, itemInventory);
      if (isDifferent) {
        loyaltyUpdateRequired = true;
        return item;
      }
      return order;
    });
  }
  const loyaltyPayload = { ...payload, loyaltyOrderItems };
  return { loyaltyUpdateRequired, loyaltyPayload };
};

export function updateOrderDetails(orderDetails, inventory, stores) {
  let updateRequired = false;
  let updatedLoyaltyPayload = {};
  const { orderItems, loyaltyPointsRequestPayload, orderAccessorieItems, orderPriceAdjustments } =
    orderDetails;
  if (orderItems && orderItems.length) {
    orderItems.forEach((order) => {
      const { productInfo, miscInfo } = order;
      const { orderType, variantNo } = productInfo;
      const { storeId } = miscInfo;
      const itemInventory = inventory.find((itm) => itm.productId === variantNo) || {};
      let store = {};
      if (orderType === ORDER_ITEM_TYPE.BOSS || orderType === ORDER_ITEM_TYPE.BOPIS) {
        store = stores.find((re) => re.id === storeId);
      }

      const { isDifferent, item } = checkDifference(order, itemInventory, store);
      if (isDifferent) {
        updateRequired = true;
        return item;
      }
      return order;
    });
  }
  if (loyaltyPointsRequestPayload) {
    const { loyaltyUpdateRequired, loyaltyPayload } = updateLoyaltyPayload(
      loyaltyPointsRequestPayload,
      inventory
    );
    updateRequired = updateRequired || loyaltyUpdateRequired;
    updatedLoyaltyPayload = loyaltyPayload;
  }
  return {
    updateRequired,
    orderItems,
    loyaltyPointsRequestPayload: updatedLoyaltyPayload,
    orderAccessorieItems,
    orderPriceAdjustments,
  };
}

export const checkCart = (baseCart, invItems) => {
  const { orderItems = [] } = baseCart;
  const cartObj = {};
  orderItems.forEach((item) => {
    const { productInfo = {}, itemInfo = {} } = item;
    const { itemPartNumber = '' } = productInfo;
    const { quantity = 0 } = itemInfo;
    cartObj[itemPartNumber] = quantity;
  });
  const invMap = invItems.map((inv) => {
    const { productId, requestedQty } = inv;
    return {
      productId,
      requestedQty,
    };
  });

  return invMap.some((rcd) => {
    return cartObj[rcd.productId] !== rcd.requestedQty;
  });
};

export const getBossQtyAvailbility = (orderItems) => {
  let isCartBossEligible = false;
  isCartBossEligible = orderItems?.every((data) => {
    const bossInventoryValue = data?.bossAvailableQty;
    if (
      bossInventoryValue &&
      (bossInventoryValue >= data?.requestedQty || bossInventoryValue !== 0)
    ) {
      return true;
    }
    return false;
  });
  return isCartBossEligible;
};

export function* resetCartCache() {
  try {
    yield call(deleteCache, [
      'getCart',
      'getBasketInventoryDetails',
      'getBonusDay',
      'getLoyaltyBenefits',
    ]);
    yield call(deleteTtlCache, [
      'GET_BASKET_INVENTORY_QUERY',
      'GET_CART_QUERY',
      'GET_BONUS_POINT_DAY',
      'GET_LOYALTY_BENEFITS',
    ]);
    yield put(BAG_PAGE_ACTIONS.clearCachedCartDataTTL());
    yield put(BAG_PAGE_ACTIONS.clearNonCachedCartDataTTL());
    yield put(resetBossUnavailableState());
  } catch (err) {
    yield put(BAG_PAGE_ACTIONS.setBagPageError(err));
  }
}
export function* makeInventoryCallSaga(payload = {}) {
  const { payload: { orderDetails, skipInvCache = true, itemsInCart = 0 } = {} } = payload;
  try {
    if (orderDetails?.totalItems || itemsInCart) {
      const { defaultTTL } = CacheConfiguration.GET_CART_ITEMS;
      const cacheTTL = yield select(getCartCacheTTL);
      const isMultiDeviceEnabled = yield select(multiDeviceEnabled);
      const killItemCountComparision = yield select(getIsKillItemCountCompare);
      const skipCache = skipInvCache && isMultiDeviceEnabled;
      yield put(setApplePayCartLoadingState(true));
      const { productList = [], storeDetails = [] } = yield call(
        fetchBasketInventoryDetails,
        (cacheTTL || defaultTTL) - 0.5,
        skipCache
      );
      const itemsCount = yield select(BAG_SELECTORS.getTotalItems);
      const requestedAddedQty =
        productList?.length > 0
          ? productList.reduce((acc, item) => acc + item?.requestedQty, 0)
          : 0;
      if (productList && productList.length) {
        const {
          updateRequired,
          orderItems,
          loyaltyPointsRequestPayload,
          orderAccessorieItems,
          orderPriceAdjustments,
        } = updateOrderDetails(orderDetails || {}, productList, storeDetails);
        const oos = orderItems?.find((data) => data?.miscInfo?.availability === 'UNAVAILABLE');
        const isSPC = yield select(SpcSelector.checkIsSinglePageCheckout);
        const errorMapping = yield select(BAG_SELECTORS.getErrorMapping);
        const isBossSwitch = yield select(getIsBOSSswitchEnabled);
        const isBosswitchAbTest = yield select(getABTestIsBOSSswitchEnabled);
        if (isBossSwitch && productList && productList.length) {
          const isBossQtyAvailable = getBossQtyAvailbility(productList);
          yield put(BAG_PAGE_ACTIONS.setBossCartAvailableFlag(isBossQtyAvailable));
        }
        if (
          isSPC &&
          isBossSwitch &&
          isBosswitchAbTest &&
          oos &&
          oos?.miscInfo?.availability === 'UNAVAILABLE'
        ) {
          yield put(
            CHECKOUT_ACTIONS.setServerErrorCheckout({
              errorMessage: errorMapping.OOS_BOSS_SWITCH_ERROR,
              component: 'PAGE',
              isSubmitOrderError: true,
            })
          );
        }
        const isCartSyncNeeded =
          !killItemCountComparision && requestedAddedQty !== itemsCount && !isCartSyncTrigerred;
        const isCartHasChanged =
          (skipCache && checkCart(orderDetails, productList)) || isCartSyncNeeded;
        if (isCartHasChanged) {
          // skipCache is used to make graphQl network call explicitly while ignoreCache is used to avoid redux cache.
          if (isCartSyncNeeded) {
            isCartSyncTrigerred = true;
          }
          yield put(BAG_PAGE_ACTIONS.getCachedCartData({ skipCache: true, ignoreCache: true }));
        }
        if (updateRequired) {
          const order = {
            orderItems,
            loyaltyPointsRequestPayload,
            orderAccessorieItems,
            orderPriceAdjustments,
          };
          yield put(BAG_PAGE_ACTIONS.getOrderDetailsPartial(order));
        }
      }
      if (orderDetails?.loyaltyPointsRequestPayload) {
        yield InjectLoyaltyDynamicStore();
        yield put(
          simulateLoyaltyDetail({
            ...orderDetails.loyaltyPointsRequestPayload,
            source: 'Cart',
          })
        );
      }
    }
  } catch {
    console.error('error fetching inventory');
  }
}
// eslint-disable-next-line sonarjs/cognitive-complexity
export function* makeInventoryCall(
  orderDetails,
  skipInvCache = true,
  skipStateUpdate,
  itemsInCart = 0
) {
  if (orderDetails?.totalItems || itemsInCart) {
    const { defaultTTL } = CacheConfiguration.GET_CART_ITEMS;
    const cacheTTL = yield select(getCartCacheTTL);
    const isMultiDeviceEnabled = yield select(multiDeviceEnabled);
    const killItemCountComparision = yield select(getIsKillItemCountCompare);
    const skipCache = skipInvCache && isMultiDeviceEnabled;
    const { productList = [], storeDetails = [] } = yield call(
      fetchBasketInventoryDetails,
      (cacheTTL || defaultTTL) - 0.5,
      skipCache
    );
    const itemsCount = yield select(BAG_SELECTORS.getTotalItems);
    const requestedAddedQty =
      productList?.length > 0 ? productList.reduce((acc, item) => acc + item?.requestedQty, 0) : 0;
    if (productList && productList.length) {
      const {
        updateRequired,
        orderItems,
        loyaltyPointsRequestPayload,
        orderAccessorieItems,
        orderPriceAdjustments,
      } = skipStateUpdate
        ? updateOrderDetailsWithoutCheck(orderDetails || {}, productList, storeDetails)
        : updateOrderDetails(orderDetails || {}, productList, storeDetails);
      const isCartSyncNeeded =
        !killItemCountComparision && requestedAddedQty !== itemsCount && !isCartSyncTrigerred;
      const isCartHasChanged =
        (skipCache && checkCart(orderDetails, productList)) || isCartSyncNeeded;
      if (isCartHasChanged) {
        // skipCache is used to make graphQl network call explicitly while ignoreCache is used to avoid redux cache.
        if (isCartSyncNeeded) {
          isCartSyncTrigerred = true;
        }
        yield put(BAG_PAGE_ACTIONS.getCachedCartData({ skipCache: true, ignoreCache: true }));
      }
      if (updateRequired) {
        const order = {
          ...(skipStateUpdate ? orderDetails : {}),
          orderItems,
          loyaltyPointsRequestPayload,
          orderAccessorieItems,
          orderPriceAdjustments,
        };
        yield put(BAG_PAGE_ACTIONS.getOrderDetailsPartial(order));
      }
    }
  }
}

// eslint-disable-next-line sonarjs/cognitive-complexity
export function* getCartDataSaga(payload = {}) {
  try {
    yield put(nonCachedDataLoading('false'));
    yield put(setSectionLoaderState({ miniBagLoaderState: false, section: 'minibag' }));
    const {
      payload: {
        respToProcess,
        isCheckoutFlow,
        // isCartPage,
        fromMoveTobag,
        ignoreCartLoader,
        skipCache,
        fromBossUnavailable,
      } = {},
    } = payload;
    const { payload: { onCartRes } = {} } = payload;
    const { payload: { isCartNotRequired, updateSmsInfo, excludeCartItems } = {} } = payload;
    let res = {};
    if (!fromBossUnavailable) {
      yield setBagPageLoading(fromMoveTobag, ignoreCartLoader);
    }

    if (!respToProcess) {
      const cacheTTL = yield select(getCartCacheTTL);
      const cachedCartData = yield call(fetchCartCachedData, cacheTTL, skipCache);
      const nonCachedCartData = yield call(fetchCartNonCachedData);
      const orderDetailsResponse = { ...cachedCartData, ...nonCachedCartData };
      res = {
        coupons: {},
        orderDetails: getCurrentOrderFormatter(orderDetailsResponse),
      };
    } else {
      res = {
        coupons: {},
        orderDetails: getCurrentOrderFormatter(respToProcess),
      };
    }
    yield put(setAddedToBagDataLocal(res.orderDetails.orderItems));
    yield put(BAG_PAGE_ACTIONS.updatePayPalStatus(res));

    if (yield call(shouldTranslate, true)) {
      const translatedProductInfo = yield call(getTranslatedProductInfo, res);
      if (!translatedProductInfo.error) {
        createMatchObject(res.orderDetails.orderItems, translatedProductInfo);
      }
    }
    const addressIds = yield select(BAG_SELECTORS.getAddressIds);
    yield handelAddressIds(res.orderDetails, addressIds);

    if (isCheckoutFlow) {
      yield put(checkoutSetCartData({ res, isCartNotRequired, updateSmsInfo }));
    } else {
      yield put(toggleCheckoutRouting(true));
    }
    yield put(updateRecommendationsLoading({ isUpdating: false }));
    yield put(BAG_PAGE_ACTIONS.getOrderDetailsComplete(res.orderDetails, excludeCartItems));
    const makeInventoryCallAsync = yield select(getMakeInventoryCallAsync);

    if (makeInventoryCallAsync && fromBossUnavailable)
      yield put(fetchInventoryDetails({ orderDetails: res.orderDetails, skipInvCache: true }));
    // Call Loyalty Points API when Brierley service is down And Get flag 'loyaltyCallEnabled' from cart Api
    yield InjectLoyaltyDynamicStore();
    yield put(
      simulateLoyaltyDetail({
        ...res.orderDetails.loyaltyPointsRequestPayload,
        source: 'Cart',
      })
    );
    yield injectCouponDynamicStore();
    yield put(getCouponList({ ignoreCache: true, appliedCoupons: res.orderDetails.c_couponMap }));

    if (onCartRes) {
      yield call(onCartRes, res);
    }
    yield put(updateMiniBagFlag(false));
    yield put(BAG_PAGE_ACTIONS.resetBagLoadingState());
    yield put(nonCachedDataLoading('true'));
  } catch (err) {
    yield put(BAG_PAGE_ACTIONS.setBagPageError(err));
    yield put(nonCachedDataLoading('true'));
  }
}

const verifyBasketIdExist = (basketId, cartItems) => {
  if (cartItems === 'SF|') {
    return false;
  }
  return basketId || cartItems;
};

const isExpressCheckoutFlow = (isExpressCheckoutEnabled, isCheckoutFlow) =>
  isExpressCheckoutEnabled && isCheckoutFlow;

function* checkPickupDetails(res) {
  const { pickUpContact = {}, pickUpAlternative = {} } = res?.orderDetails?.checkout;
  if (Object.keys(pickUpContact)?.length && pickUpContact?.firstName) {
    yield put(getSetPickupValuesActn(pickUpContact));
  }
  if (Object.keys(pickUpAlternative)?.length && pickUpAlternative?.firstName) {
    yield put(getSetPickupAltValuesActn(pickUpAlternative));
  }
}

export function* getCachedCartDataSaga(payload = {}) {
  try {
    yield put(setSectionLoaderState({ miniBagLoaderState: false, section: 'minibag' }));
    const {
      payload: {
        fromMoveTobag,
        ignoreCartLoader,
        onCartRes,
        isCheckoutFlow,
        isCartNotRequired,
        updateSmsInfo,
        skipCache,
        itemsInCart,
        skipInventoryCall,
        addToBagResponse,
      } = {},
    } = payload;

    yield setBagPageLoading(fromMoveTobag, ignoreCartLoader, skipCache);
    let cachedCartData = {};
    const basketId = getBasketId();
    const cartItems = readCookie('cartItems');
    if (verifyBasketIdExist(basketId, cartItems)) {
      const cacheTTL = yield select(getCartCacheTTL);
      cachedCartData = yield call(fetchCartCachedData, cacheTTL, skipCache);
    }
    let res = formatCachedResponse(cachedCartData, addToBagResponse);
    yield checkPickupDetails(res);
    if (yield call(shouldTranslate, true)) {
      const translatedProductInfo = yield call(getTranslatedProductInfo, res);
      if (!translatedProductInfo.error) {
        createMatchObject(res.orderDetails.orderItems, translatedProductInfo);
      }
    }
    const getShippingTotalFromRedux = yield select(getShippingTotal);
    const setShippingTotalInCacheEnabled = yield select(getSetShippingTotalInCache);

    // to refresh basket based on updated shippingTotal after coming back from checkout page
    if (
      !skipCache &&
      res.orderDetails.shippingTotal !== getShippingTotalFromRedux &&
      verifyBasketIdExist(basketId, cartItems) &&
      !addToBagResponse &&
      setShippingTotalInCacheEnabled
    ) {
      const cacheTTL = yield select(getCartCacheTTL);
      cachedCartData = yield call(fetchCartCachedData, cacheTTL, true);
    }
    res = formatCachedResponse(cachedCartData, addToBagResponse);

    yield put(BAG_PAGE_ACTIONS.getOrderDetailsPartial(res.orderDetails));

    if (isCheckoutFlow) {
      yield put(checkoutSetCartData({ res, isCartNotRequired, updateSmsInfo }));
    } else {
      yield put(toggleCheckoutRouting(true));
    }
    yield put(BAG_PAGE_ACTIONS.updatePayPalStatus(res));
    const makeInventoryCallAsync = yield select(getMakeInventoryCallAsync);

    let skipCacheFlag = true;
    skipCacheFlag = !isCheckoutFlow ? !skipCache : false;
    if (skipInventoryCall) {
      skipCacheFlag = false;
    }
    if (makeInventoryCallAsync) {
      yield put(
        fetchInventoryDetails({
          orderDetails: res.orderDetails,
          skipInvCache: skipCacheFlag,
          itemsInCart,
        })
      );
    } else {
      yield makeInventoryCall(res.orderDetails, skipCacheFlag, itemsInCart);
    }
    yield InjectLoyaltyDynamicStore();
    yield put(
      simulateLoyaltyDetail({
        ...res.orderDetails.loyaltyPointsRequestPayload,
        source: 'Cart',
      })
    );
    yield put(BAG_PAGE_ACTIONS.resetBagLoadingState());

    const cacheTTL = yield select(getCartCacheTTL);
    const { preFix, defaultTTL } = CacheConfiguration.GET_CART_ITEMS;
    const ttl = calculateReduxCachedCartTTL(cacheTTL || defaultTTL, `${preFix}`);
    yield put(BAG_PAGE_ACTIONS.setCachedCartDataTTL(ttl));

    yield put(updateRecommendationsLoading({ isUpdating: false }));

    if (onCartRes) {
      yield call(onCartRes, res);
    }
    yield put(updateMiniBagFlag(false));
    yield put(BAG_PAGE_ACTIONS.setGetCartItemComplete());
    yield put(BAG_PAGE_ACTIONS.resetBagLoadingState());
    yield put(setBagLoadingStatus(false));
  } catch (err) {
    yield put(setBagLoadingStatus(false));
    yield put(BAG_PAGE_ACTIONS.setBagPageError(err));
    yield put(BAG_PAGE_ACTIONS.setGetCartItemComplete());
  }
}
function* processLoyaltyBenefits(respToProcess, isLoyaltyBenefitsCacheUpdate) {
  const isLoyaltyTieringEnabled = yield select(getIsLoyaltyTieringEnabled);
  if (isLoyaltyTieringEnabled && isLoyaltyBenefitsCacheUpdate) {
    const { benefits = {}, productItems = [] } = respToProcess;
    yield injectCouponDynamicStore();
    yield put(setBenefits({ benefits, productItems }));
  }
}
export function* processMutationCachedDataSaga(payload = {}) {
  try {
    const {
      payload: {
        respToProcess,
        skipStateUpdate,
        skipCache = true,
        isLoyaltyBenefitsCacheUpdate = false,
      } = {},
    } = payload;
    const { payload: { onCartRes } = {} } = payload;
    const { pointsToRedeem = '0' } = respToProcess;
    yield call(processLoyaltyBenefits, respToProcess, isLoyaltyBenefitsCacheUpdate);
    yield put(setPointsToRedeem(parseInt(pointsToRedeem, 10)));
    const res = formatCachedResponse(respToProcess);
    if (yield call(shouldTranslate, true)) {
      const translatedProductInfo = yield call(getTranslatedProductInfo, res);
      if (!translatedProductInfo.error) {
        createMatchObject(res.orderDetails.orderItems, translatedProductInfo);
      }
    }
    const skipCacheValue = skipCache;
    const isBossSwitch = yield select(getIsBOSSswitchEnabled);
    const isBosswitchAbTest = yield select(getABTestIsBOSSswitchEnabled);
    const isSPC = yield select(SpcSelector.checkIsSinglePageCheckout);
    const isInvCallNeeded = !isSPC || (isBossSwitch && isBosswitchAbTest);
    if (!skipStateUpdate || !isInvCallNeeded || !res.orderDetails?.totalItems) {
      yield put(BAG_PAGE_ACTIONS.getOrderDetailsPartial(res.orderDetails));
    }
    const makeInventoryCallAsync = yield select(getMakeInventoryCallAsync);
    if (isInvCallNeeded) {
      if (makeInventoryCallAsync && !skipStateUpdate) {
        yield put(
          fetchInventoryDetails({ orderDetails: res.orderDetails, skipInvCache: skipCache })
        );
      } else {
        yield makeInventoryCall(res.orderDetails, skipCacheValue, skipStateUpdate);
      }
    }
    yield put(setApplePayCartLoadingState(true));
    yield InjectLoyaltyDynamicStore();
    yield put(
      simulateLoyaltyDetail({
        ...res.orderDetails.loyaltyPointsRequestPayload,
        source: 'Cart',
      })
    );
    if (onCartRes) {
      yield call(onCartRes, res);
    }
    if (res?.orderDetails?.orderItems?.length === 0) {
      yield put(setAddedToBagDataLocal([]));
    }
  } catch (err) {
    yield put(BAG_PAGE_ACTIONS.setBagPageError(err));
  }
}

export function* getCartDataSequentially() {
  const state = yield select();
  const fromAvailableStoreClick = state?.ProductPickup?.get('fromAvailableStoreClick');
  if (fromAvailableStoreClick) {
    yield put(fromAvailableStoresClickReset());
  }
  const isCachedCartReduxExist = yield validateCache({
    type: BAGPAGE_CONSTANTS.GET_CACHED_CART_DATA,
  });
  const isMultiDeviceEnabled = yield select(multiDeviceEnabled);
  if (isMultiDeviceEnabled || !isCachedCartReduxExist) {
    yield put(BAG_PAGE_ACTIONS.getCachedCartData());
    yield take(BAGPAGE_CONSTANTS.GET_CACHED_CART_DATA_COMPLETED);
  }
  const isNonCachedCartReduxExist = yield validateCache({
    type: BAGPAGE_CONSTANTS.GET_NON_CACHED_CART_DATA,
  });
  if (!isNonCachedCartReduxExist) {
    yield put(BAG_PAGE_ACTIONS.getNonCachedCartData());
    yield take(BAGPAGE_CONSTANTS.GET_NON_CACHED_CART_DATA_COMPLETED);
  }
}

function* setCartData(isCheckoutFlow, res, isCartNotRequired, updateSmsInfo) {
  yield put(updateCartShipmentMethod(res?.orderDetails?.checkout?.shipping));
  if (isCheckoutFlow) {
    yield put(checkoutSetCartData({ res, isCartNotRequired, updateSmsInfo }));
  } else {
    yield put(toggleCheckoutRouting(true));
  }
}

// eslint-disable-next-line sonarjs/cognitive-complexity
export function* getNonCachedCartDataSaga(payload = {}) {
  try {
    yield put(nonCachedDataLoading('false'));
    const { payload: { isCheckoutFlow, disableLoading = false, promo = [] } = {} } = payload;

    const { payload: { onCartRes } = {} } = payload;
    const { payload: { isCartNotRequired, updateSmsInfo } = {} } = payload;
    const { earliestPromoExpiry } = getEarliestPromoStartDateEndDate(promo);
    const isApplyCheckboxPromoOnPdp = yield select(getIsApplyCheckboxPromoOnPDPEnabled);
    const isExpressCheckoutEnabled = yield select(isExpressCheckout);
    let nonCachedCartData = {};
    if (!disableLoading) {
      yield put(BAG_PAGE_ACTIONS.setNonCacheBagPageLoading());
    }
    const basketId = getBasketId();
    const cartItems = readCookie('cartItems');
    if (verifyBasketIdExist(basketId, cartItems)) {
      if (isExpressCheckoutFlow(isExpressCheckoutEnabled, isCheckoutFlow)) {
        yield put(setSubmitButtonState(true));
        nonCachedCartData = yield call(getExpressCheckoutData);
        const isSuppressCvvFieldEnabled = yield select(getSuppressCvvField);
        if (isSuppressCvvFieldEnabled) {
          const { suppressCCheck = false } = nonCachedCartData;
          yield put(setSuppressCCheck(suppressCCheck));
        }
        const sfsError = yield select(getSfsError);
        if (nonCachedCartData?.basketError && !sfsError) {
          yield put(setSFSErrors(nonCachedCartData?.basketError));
        }
      } else {
        yield put(setApplePayCartLoadingState(true));
        nonCachedCartData = yield call(fetchCartNonCachedData);
      }
    }
    const res = formatNonCachedResponse(nonCachedCartData);
    if (res && isExpressCheckoutFlow(isExpressCheckoutEnabled, isCheckoutFlow)) {
      yield put(isExpressUserCallDone(true));
    }
    if (res && isCheckoutFlow) {
      yield put(isNonCachedCartDataCallDone(true));
    }
    yield checkPickupDetails(res);
    const addressIds = yield select(BAG_SELECTORS.getAddressIds);
    yield handelAddressIds(res.orderDetails, addressIds);
    if (isCheckoutFlow) {
      yield put(checkoutSetCartData({ res, isCartNotRequired, updateSmsInfo }));
    } else {
      yield put(toggleCheckoutRouting(true));
    }
    yield call(setCartData, isCheckoutFlow, res, isCartNotRequired, updateSmsInfo);
    yield put(BAG_PAGE_ACTIONS.getOrderDetailsPartial(res.orderDetails));
    yield put(BAG_PAGE_ACTIONS.resetNonCacheBagLoadingState());
    const cacheTTL = yield select(getCartCacheTTL);
    const { preFix, defaultTTL } = CacheConfiguration.GET_CART_DETAILS;
    let ttl = calculateReduxCachedCartTTL(cacheTTL || defaultTTL, `${preFix}`);
    if (
      isApplyCheckboxPromoOnPdp &&
      earliestPromoExpiry &&
      ttl > earliestPromoExpiry &&
      ttl < earliestPromoExpiry + 30 * 60 * 1000
    ) {
      ttl -= ttl - (ttl - earliestPromoExpiry);
    }
    yield put(BAG_PAGE_ACTIONS.setNonCachedCartDataTTL(ttl));
    yield injectCouponDynamicStore();
    yield put(setApplePayCartLoadingState(true));
    yield put(getCouponList({ ignoreCache: true, appliedCoupons: res.orderDetails.c_couponMap }));
    if (onCartRes) {
      yield call(onCartRes, res);
    }
    yield put(BAG_PAGE_ACTIONS.setGetCartDetailComplete());
    yield put(setSubmitButtonState(false));
    yield put(nonCachedDataLoading('true'));
  } catch (err) {
    yield put(BAG_PAGE_ACTIONS.setBagPageError(err));
    yield put(BAG_PAGE_ACTIONS.resetNonCacheBagLoadingState());
    yield put(BAG_PAGE_ACTIONS.setGetCartDetailComplete());
    yield put(setSubmitButtonState(false));
    yield put(nonCachedDataLoading('true'));
  }
}
export function* processMutationNonCachedDataSaga(payload = {}) {
  // if from checkout flow then update addtobag page reduser with loyalty gift
  try {
    const {
      payload: {
        respToProcess,
        isCheckoutFlow,
        ignoreCache = true,
        fromSMSCheckBox,
        skipLoyaltyApi = false,
      } = {},
    } = payload;
    const { payload: { onCartRes } = {} } = payload;
    const { payload: { isCartNotRequired, updateSmsInfo } = {} } = payload;
    const res = formatNonCachedResponse(respToProcess);
    const addressIds = yield select(BAG_SELECTORS.getAddressIds);
    yield handelAddressIds(res.orderDetails, addressIds);

    if (isCheckoutFlow) {
      yield put(checkoutSetCartData({ res, isCartNotRequired, updateSmsInfo }));
    } else {
      yield put(toggleCheckoutRouting(true));
    }
    if (!fromSMSCheckBox) {
      yield put(BAG_PAGE_ACTIONS.getOrderDetailsPartial(res.orderDetails));
    }
    yield injectCouponDynamicStore();
    // SFCC-TODO refactor
    if (!fromSMSCheckBox) {
      // getting called here
      if (skipLoyaltyApi) {
        const guestUser = yield select(getIsGuest);
        yield call(loyaltyCouponUpdateBPD, guestUser, [], skipLoyaltyApi);
      } else {
        yield put(getCouponList({ ignoreCache, appliedCoupons: res.orderDetails.c_couponMap }));
      }
    }
    if (onCartRes) {
      yield call(onCartRes, res);
    }
  } catch (err) {
    yield put(BAG_PAGE_ACTIONS.setBagPageError(err));
  }
}
export const mergeTwoObjects = (obj1, obj2) => {
  const list1 = List(obj1);
  const list2 = List(obj2);
  const newList = [];
  list1.map((ele) => {
    if (list2.size > 0) {
      list2.map((ele2) => {
        if (ele && ele.name !== ele2.name) {
          if (newList.map((e) => e.name).indexOf(ele2.name) === -1) {
            return newList.push(ele2);
          }
          if (newList.map((e) => e.name).indexOf(ele.name) === -1) {
            return newList.push(ele);
          }
        }
        return newList;
      });
    }
    if (newList.map((e) => e.name).indexOf(ele.name) === -1) {
      return newList.push(ele);
    }
    return newList;
  });
  return newList;
};

export function* fetchModuleX({ payload: contentList = [] }) {
  try {
    const moduleXContentList = yield select(getCartModuleXList);
    const payload = contentList.filter((content) => {
      if (content) {
        const { name: contentName } = content;
        return !moduleXContentList.find(({ name }) => name === contentName);
      }
      return false;
    });
    let result = yield call(getModuleX, payload);
    result = Object.keys(result).map((name) => {
      const richText = result[name];
      return { richText, name };
    });
    const mergedModuleX = mergeTwoObjects(result, moduleXContentList);
    yield put(BAG_PAGE_ACTIONS.setModuleX(mergedModuleX));
  } catch (err) {
    yield null;
  }
}

/**
 * routeForCartCheckout component. This is responsible for routing our web to specific page of checkout journey.
 * @param {Boolean} recalc query parameter for recalculation of points
 * @param {Object} navigation for navigating in mobile app
 * @param {Boolean} closeModal for closing addedtoBag modal in app
 */
export function* routeForCartCheckout({ recalc, isAddedToBag }) {
  yield put(setLoaderState(true));
  yield put(BAG_PAGE_ACTIONS.setBagPageIsRouting(true));
  const isRegisteredUserCallDone = yield select(getIsRegisteredUserCallDone);
  if (!isRegisteredUserCallDone) {
    yield call(getUserInfoSaga);
  }
  yield put(setLoaderState(false));
  const { hasVenmoReviewPageRedirect } = checkoutSelectors;
  const IsInternationalShipping = yield select(getIsInternationalShipping);
  const isExpressCheckoutEnabled = yield select(isExpressCheckout);
  const hasVenmoReviewPage = yield select(hasVenmoReviewPageRedirect);
  if (!IsInternationalShipping) {
    yield put(closeMiniBag());
    yield call(
      getRouteToCheckoutStage,
      { recalc, fromATB: isAddedToBag },
      hasVenmoReviewPage || isExpressCheckoutEnabled,
      true
    );
  } else {
    utility.routeToPage(CHECKOUT_ROUTES.internationalCheckout);
  }
}

export function* checkoutCart(
  recalc,
  navigation,
  closeModal,
  navigationActions,
  spcPage,
  isAddedToBag
) {
  const isVenmoPaymentInProgress = yield select(checkoutSelectors.isVenmoPaymentInProgress);
  const isLoggedIn = yield select(getUserLoggedInState);
  const isRememberedUser = yield select(isRemembered);
  // For Venmo, we need to show remember me user login modal.
  if (
    (!isLoggedIn && !isVenmoPaymentInProgress) ||
    (isVenmoPaymentInProgress && isRememberedUser)
  ) {
    yield put(BAG_PAGE_ACTIONS.setCartSupressOnBagUpdate(true));
    yield put(setSectionLoaderState({ addedToBagLoaderState: false, section: 'addedtobag' }));
    yield put(setSectionLoaderState({ miniBagLoaderState: false, section: 'minibag' }));
    yield put(setLoaderState(false));

    const isLoginV2FlowEnabled = yield select(getLoginV2FlowEnabled);
    const isOTpScreenEnabled = yield select(getIsOTpScreenEnabled);
    const isRegistered = yield select(getUserLoggedInState);

    const isUnverifiedAccount = yield select(getShowVerificationError);
    if (isLoginV2FlowEnabled) {
      let savedContactFormData = getSessionStorage(CONTACT_FORM);
      let parsedData;
      try {
        parsedData = JSON.parse(savedContactFormData);
      } catch (error) {
        parsedData = {};
      }
      savedContactFormData = parsedData;
      const { emailAddress, vstatus, otpLimit, isCreateAccountOtpScreen } =
        savedContactFormData ?? {};
      if (
        isOTpScreenEnabled &&
        ((vstatus !== undefined && !vstatus) || isUnverifiedAccount || isCreateAccountOtpScreen) &&
        !otpLimit &&
        emailAddress &&
        !isRegistered
      ) {
        yield put(
          emailSubmit({
            emailAddress,
            plcc_checkbox: !isCanada(),
            rememberMe: true,
            savePlcc: true,
          })
        );
      }
      return utility.routeToPage(CHECKOUT_ROUTES.loginCheckout);
    }
    yield LoginPageDynamicStore();
    return yield put(setCheckoutModalMountedState({ state: true }));
  }
  return yield call(routeForCartCheckout, {
    navigation,
    closeModal,
    recalc,
    navigationActions,
    spcPage,
    isAddedToBag,
  });
}

export function* confirmStartCheckout() {
  // this.store.dispatch(setVenmoData({ error: null })); // Clear Venmo error message
  // if (cartStoreView.getIsEditingSomeItem(state)) {
  //   // editing an item, display warning modal
  //   confirmationsResult = confirmationsResult.then(() =>
  //     generalOperator.openConfirmationModal(CONFIRM_MODAL_IDS.EDITING, null, null)
  //   );
  // }

  const [OOSCount, unavailableCount, offlineProductCount] = yield all(
    [
      BAG_SELECTORS.getOOSCount,
      BAG_SELECTORS.getUnavailableCount,
      BAG_SELECTORS.getOfflineProductCount,
    ].map((val) => select(val))
  );
  if (OOSCount > 0 || unavailableCount > 0 || offlineProductCount > 0) {
    yield put(setSectionLoaderState({ addedToBagLoaderState: false, section: 'addedtobag' }));
    yield put(setSectionLoaderState({ miniBagLoaderState: false, section: 'minibag' }));
    yield put(setLoaderState(false));
    yield put(BAG_PAGE_ACTIONS.openCheckoutConfirmationModal());
    return yield true;
  }
  return false;
}

export function* getUnqualifiedItemsCall(isCartDetailsCallNeeded) {
  const taxIdentifierAttribute = yield select(BAG_SELECTORS.getTaxIdentifier);
  const { isTaxChanged, basketError, orderItemProductsList, availableList, unavailableList } =
    yield call(getUnqualifiedItems, taxIdentifierAttribute);
  let itemsCount = yield select(BAG_SELECTORS.getTotalItems);
  const killItemCountComparision = yield select(getIsKillItemCountCompare);
  const requestedAccumulatedQty =
    orderItemProductsList?.length > 0
      ? orderItemProductsList.reduce((acc, item) => acc + item?.requestedQty, 0)
      : 0;
  const checkoutServerError = yield select(checkoutSelectors.getCheckoutServerError);
  const getGiftWrappingTotal = yield select(BAG_SELECTORS.getGiftWrappingTotal);
  if (getGiftWrappingTotal) {
    itemsCount += 1;
  }
  if (
    requestedAccumulatedQty !== itemsCount &&
    !checkoutServerError?.isSubmitOrderError &&
    !killItemCountComparision &&
    !isCartSyncTrigerred
  ) {
    isCartSyncTrigerred = true;
    yield call(resetCartCache);
    yield put(BAG_PAGE_ACTIONS.getCartDataSequentially());
  }
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem('sfsError');
  }
  if (basketError) {
    yield put(setSFSErrors(basketError));
    setLocalStorage({ key: 'sfsError', value: JSON.stringify(basketError) });
  }
  if (isTaxChanged) {
    yield put(BAG_PAGE_ACTIONS.clearNonCachedCartDataTTL());
  }

  const orderItemsCartPage = yield select(BAG_SELECTORS.getOrderItems);
  const newCartOrderItems = orderItemsCartPage.map((cartItem) => {
    const cartItemId = cartItem?.getIn(['itemInfo', 'itemId']);
    const isPackAndHold = cartItem?.getIn(['miscInfo', 'isPackAndHold']);
    const avaliableItem = availableList?.find((listItem) => listItem === cartItemId);
    const unavaliableItem = unavailableList?.find((listItem) => listItem === cartItemId);
    if (avaliableItem && !isPackAndHold) {
      return cartItem?.setIn(['miscInfo', 'availability'], AVAILABILITY.OK);
    }
    if (unavaliableItem || isPackAndHold) {
      return cartItem?.setIn(['miscInfo', 'availability'], AVAILABILITY.UNAVAILABLE);
    }
    return cartItem;
  });
  yield put(BAG_PAGE_ACTIONS.setItems(newCartOrderItems));

  if (isTaxChanged && isCartDetailsCallNeeded) {
    const cart = yield call(getCartCachedDataApplePay);
    const orderDetails = getCurrentOrderFormatter(cart);
    yield put(BAG_PAGE_ACTIONS.getOrderDetailsCompleteApplePay(orderDetails));
  }
}

export function* startCartCheckout({
  payload: {
    isEditingItem,
    navigation,
    closeModal,
    navigationActions,
    isMiniBag,
    isAddedToBag,
    spcPage = false,
    isPlccInstantCheckout = false,
  } = {},
} = {}) {
  try {
    yield put(setCheckoutInProgress(true));
    if (isEditingItem) {
      yield put(BAG_PAGE_ACTIONS.openCheckoutConfirmationModal({ isEditingItem }));
    } else {
      if (isMiniBag) {
        yield put(setSectionLoaderState({ miniBagLoaderState: true, section: 'minibag' }));
      }
      if (isAddedToBag) {
        yield put(setSectionLoaderState({ addedToBagLoaderState: true, section: 'addedtobag' }));
      }
      if (!isPlccInstantCheckout) {
        yield call(getUnqualifiedItemsCall);
      }
      const oOSModalOpen = yield call(confirmStartCheckout);
      const isPersistEddEnabledGlobal = yield select(isPersistEddGlobalEnabled);
      const isPersistEddEnabled = yield select(isPersistEddCartPageEnabled);
      if (!oOSModalOpen) {
        if (isPersistEddEnabled && isPersistEddEnabledGlobal) {
          yield fork(callPersistData);
        }
        yield call(
          checkoutCart,
          false,
          navigation,
          closeModal,
          navigationActions,
          spcPage,
          isAddedToBag
        );
      }
    }
    yield put(setSectionLoaderState({ checkoutLoader: false, section: 'checkout' }));
    yield put(setCheckoutInProgress(false));
    yield put(setLoaderState(false));
    yield put(setPlccLoginLoadingState(false));
  } catch (e) {
    yield put(setSectionLoaderState({ checkoutLoader: false, section: 'checkout' }));
    yield put(setSectionLoaderState({ miniBagLoaderState: false, section: 'minibag' }));
    yield put(setSectionLoaderState({ addedToBagLoaderState: false, section: 'addedtobag' }));
    yield put(setLoaderState(false));
    yield put(setCheckoutInProgress(false));
    yield put(setPlccLoginLoadingState(false));
    yield call(handleServerSideErrorAPI, e, 'CHECKOUT');
  }
}
export function* startPlccCheckout({ payload }) {
  try {
    const {
      navigation,
      navigationActions,
      fromPlccICLogin,
      rememberedUserFlag,
      fromBagPage,
      fromLoginModal,
    } = payload || {};
    const isPlccIC = true;
    if (!fromPlccICLogin) {
      yield put(setLoaderState(true));
    }
    yield call(getUnqualifiedItemsCall);
    const oOSModalOpen = yield call(confirmStartCheckout);
    if (!oOSModalOpen) {
      if (fromBagPage && rememberedUserFlag && !fromLoginModal) {
        yield put(togglePlccLoginModal(true));
        yield put(setLoaderState(false));

        return;
      }
      const res = yield call(getExpressCheckoutData, isPlccIC);
      const isPersistEddEnabledGlobal = yield select(isPersistEddGlobalEnabled);
      const isPersistEddEnabled = yield select(isPersistEddCartPageEnabled);
      if (isPersistEddEnabled && isPersistEddEnabledGlobal) {
        yield fork(callPersistData);
      }
      if (res?.basketError) {
        yield put(
          BAG_PAGE_ACTIONS.startCheckout({
            isBagPage: true,
            isPlccInstantCheckout: true,
            navigation,
            navigationActions,
            spcPage: true,
          })
        );
      } else {
        yield put(
          submitReviewSection({
            isPlccInstantCheckout: true,
            navigation,
            navigationActions,
            hideLoader: true,
          })
        );
      }
    }
  } catch (e) {
    yield put(setLoaderState(false));
    yield put(setPlccLoginLoadingState(false));
    yield call(handleServerSideErrorAPI, e, 'CHECKOUT');
  }
}

export function* startPaypalCheckout({ payload }) {
  const { resolve, reject, isBillingPage } = payload;
  try {
    let oOSModalOpen = false;
    if (!isBillingPage) {
      yield call(getUnqualifiedItemsCall);
      oOSModalOpen = yield call(confirmStartCheckout);
    }
    const errorMapping = yield select(BAG_SELECTORS.getErrorMapping);

    if (!oOSModalOpen) {
      const basketId = getBasketId();
      const fromPage = isBillingPage ? 'CHECKOUT_PAGE' : 'CART_PAGE';
      const estimatedTax = yield select(BAG_SELECTORS.getCalculatedEstimatedTax);
      const res = yield call(
        startPaypalCheckoutAPI,
        basketId,
        fromPage,
        errorMapping,
        estimatedTax
      );
      if (res) {
        yield put(getSetIsPaypalPaymentSettings(res));
        resolve(res?.paypalInContextToken);
      }
    } else {
      yield put(BAG_PAGE_ACTIONS.setPayPalModalActionOOS(true));
      throw new Error();
    }
  } catch (e) {
    const errorMapping = yield select(BAG_SELECTORS.getErrorMapping);
    const errCode = e.errorCodes;
    const errMsg = errorMapping[errCode] || errorMapping.PAYPAL_CC_ERROR_CODE_GENERIC_ERROR;
    yield put(
      CHECKOUT_ACTIONS.setServerErrorCheckout({
        errorMessage: errMsg,
        component: 'PAGE',
        isSubmitOrderError: true,
      })
    );
    reject(e);
  }
}

export function* startApplePayCheckout() {
  try {
    yield call(getUnqualifiedItemsCall);
    const oOSModalOpen = yield call(confirmStartCheckout);
    if (!oOSModalOpen) {
      return yield true;
    }
    return oOSModalOpen;
  } catch (e) {
    throw new Error();
  }
}

export function* startAfterPayExpressCheckout() {
  try {
    yield call(getUnqualifiedItemsCall);
    const isOOSModalOpen = yield call(confirmStartCheckout);
    if (!isOOSModalOpen) {
      yield put(BAG_PAGE_ACTIONS.setAfterPayPopupOpen(true));
      return yield true;
    }
    yield put(BAG_PAGE_ACTIONS.setAfterPayPopupOpen(false));
    yield put(setAfterPayPaymentProgress(false));
    yield put(BAG_PAGE_ACTIONS.setPayPalModalActionOOS(true));
    return isOOSModalOpen;
  } catch (e) {
    throw new Error();
  }
}

export function* openApayUnqualifiedItemModal({
  payload: { items, fromApplePayBillingPage } = {},
}) {
  if (items) {
    yield all(
      // eslint-disable-next-line sonarjs/no-identical-functions
      items.map(({ orderItemId, isOOS }) =>
        isOOS
          ? put(BAG_PAGE_ACTIONS.setItemOOS(orderItemId))
          : put(BAG_PAGE_ACTIONS.setItemUnavailable(orderItemId))
      )
    );
    yield put(BAG_PAGE_ACTIONS.openCheckoutConfirmationModal({ fromApplePayBillingPage }));
    yield put(BAG_PAGE_ACTIONS.setApplePayModalActionOOS(true));
  }
}

export function* startPaypalNativeCheckout({ payload }) {
  try {
    const { isBillingPage } = payload;
    yield put(getSetIsPaypalPaymentSettings(null));
    yield put(BAG_PAGE_ACTIONS.setIsGettingPaypalSettings(true));
    const basketId = getBasketId();
    const fromPage = isBillingPage ? 'CHECKOUT_PAGE' : 'CART_PAGE';
    const estimatedTax = yield select(BAG_SELECTORS.getCalculatedEstimatedTax);
    const res = yield call(startPaypalCheckoutAPI, basketId, fromPage, estimatedTax);
    if (res && Object.keys(res).length !== 0) {
      yield put(getSetIsPaypalPaymentSettings(res));
    }
    yield put(BAG_PAGE_ACTIONS.setIsGettingPaypalSettings(false));
  } catch (e) {
    yield call(handleServerSideErrorAPI, e, 'CHECKOUT');
    yield put(BAG_PAGE_ACTIONS.setIsGettingPaypalSettings(false));
  }
}

export function* authorizePayPalPayment() {
  try {
    const { tcpOrderId, centinelRequestPage, centinelPayload, centinelOrderId } = yield select(
      checkoutSelectors.getPaypalPaymentSettings
    );
    const errorMapping = yield select(BAG_SELECTORS.getErrorMapping);
    const params = [
      tcpOrderId,
      centinelRequestPage,
      centinelPayload,
      centinelOrderId,
      errorMapping,
    ];
    yield put(BAG_PAGE_ACTIONS.isPaypalRenderDone(false));
    yield put(setLoaderState(true));
    yield put(setSpcButtonLoader({ id: SPC_BUTTON.SAVE_PAYMENT, isLoading: true }));
    yield put(CHECKOUT_ACTIONS.setServerErrorCheckout({}));
    const res = yield call(paypalAuthorizationAPI, ...params);
    yield put(setVenmoPaymentInProgress(false));
    if (res?.c_couponMap) {
      yield injectCouponDynamicStore();
      yield put(clearCouponTTL());
    }
    yield put(setApplePaymentInProgress(false));
    yield put(setAfterPayInProgress(false));
    if (res) {
      yield put(setLoaderState(false));
      yield put(setApplePayDefault(false));
      removeSessionStorage('defaultAfterPay');
      yield put(setSpcButtonLoader({ id: SPC_BUTTON.SAVE_PAYMENT, isLoading: false }));
      yield put(getSetIsPaypalPaymentSettings(null));
      yield call(processMutationNonCachedDataSaga, {
        payload: {
          respToProcess: res,
          isCheckoutFlow: true,
          ignoreCache: false,
        },
      });
      yield put(recalibrateSectionStates());
      const isPersistEddEnabled = yield select(isPersistEddCartPageEnabled);
      const isPersistEddEnabledGlobal = yield select(isPersistEddGlobalEnabled);
      if (isPersistEddEnabled && isPersistEddEnabledGlobal) {
        yield fork(callPersistData);
      }
      yield put(closeMiniBag());
      utility.routeToPage(CHECKOUT_ROUTES.singlePageCheckoutPagePaypal);
    }
  } catch (e) {
    yield put(setLoaderState(false));
    yield call(handleServerSideErrorAPI, e, 'CHECKOUT');
    yield put(closeMiniBag());
    yield put(BAG_PAGE_ACTIONS.setIsPaypalBtnHidden(true));
    const isSPC = yield select(SpcSelector.checkIsSinglePageCheckout);
    if (!isSPC) {
      routerPush('/bag', '/bag');
    }
    yield put(setSpcButtonLoader({ id: SPC_BUTTON.SAVE_PAYMENT, isLoading: false }));
  }
}

export const getAccessoriesProductData = (
  unqualifiedItemsIds,
  orderItemsCartPage,
  orderAccessorieItems
  // eslint-disable-next-line sonarjs/cognitive-complexity
) => {
  const itemIds = unqualifiedItemsIds;
  const orderItems = orderItemsCartPage && JSON.parse(JSON.stringify(orderItemsCartPage));
  const orderAccessorieItemsParsed =
    orderAccessorieItems && JSON.parse(JSON.stringify(orderAccessorieItems));
  const backpackItem = [];
  try {
    if (orderItems && orderItems.length) {
      orderItems.forEach((item) => {
        const { itemInfo, miscInfo } = item;
        const {
          c_mainProducts: mainProducts,
          c_accessories: accessories,
          c_customizationType: customizationType,
        } = miscInfo;
        const { itemId } = itemInfo;
        const index = itemIds.indexOf(itemId);
        if (index > -1 && (mainProducts?.length || accessories?.length)) {
          itemIds.splice(index, 1);
          if (mainProducts?.length) {
            mainProducts.forEach((text) => {
              const id = String(text).split('#')[0];
              const mainProductInfo = orderAccessorieItemsParsed[id];
              const { itemInfo: itemInfoMainProduct, miscInfo: miscInfoMainProduct } =
                mainProductInfo || {};
              const { itemId: itemIdMainProduct } = itemInfoMainProduct || {};
              const { c_customizationType: customizationTypeMainProduct } =
                miscInfoMainProduct || {};
              if (customizationTypeMainProduct === 'mandatory') {
                backpackItem.push(itemIdMainProduct);
              }
              const mainProductIndex = itemIds.indexOf(itemIdMainProduct);
              if (mainProductIndex > -1) {
                itemIds.splice(mainProductIndex, 1);
              }
            });
          }
          backpackItem.push(itemId);
          if (customizationType === 'mandatory' && accessories?.length) {
            accessories.forEach((id) => {
              const accessoryInfo = orderAccessorieItemsParsed[id];
              const { itemInfo: itemInfoAccessory } = accessoryInfo || {};
              const { itemId: itemIdAccessory } = itemInfoAccessory || {};
              backpackItem.push(itemIdAccessory);
              const accessoryIndex = itemIds.indexOf(itemIdAccessory);
              if (accessoryIndex > -1) {
                itemIds.splice(accessoryIndex, 1);
              }
            });
          }
        }
      });
    }
  } catch (e) {
    return {
      unqualifiedItemsIds: itemIds,
      backPackProducts: backpackItem,
    };
  }
  return {
    unqualifiedItemsIds: itemIds,
    backPackProducts: backpackItem,
  };
};

export function* removeUnqualifiedItemsAndCheckout({
  navigation,
  closeModal,
  navigationActions,
} = {}) {
  yield put(setLoaderState(true));
  const labels = yield select(BAG_SELECTORS.getErrorMapping);
  let unqualifiedItemsIds = yield select(BAG_SELECTORS.getUnqualifiedItemsIds);
  let unqualifiedItems = yield select(BAG_SELECTORS.getUnqualifiedItems);
  unqualifiedItems = unqualifiedItems && JSON.parse(JSON.stringify(unqualifiedItems));
  unqualifiedItemsIds = unqualifiedItemsIds && JSON.parse(JSON.stringify(unqualifiedItemsIds));
  let backPackProducts = [];
  const isAccessoryEnabled = yield select(getIsAccessoryEnabled);
  if (isAccessoryEnabled) {
    const orderItemsCartPage = yield select(BAG_SELECTORS.getOrderItems);
    const orderAccessorieItems = yield select(BAG_SELECTORS.getorderAccessorieItems);
    ({ unqualifiedItemsIds, backPackProducts } = getAccessoriesProductData(
      unqualifiedItemsIds,
      orderItemsCartPage,
      orderAccessorieItems
    ));
  }

  if ((unqualifiedItemsIds && unqualifiedItemsIds.length > 0) || backPackProducts.length) {
    const bossUnavailableSwitch = yield select(getBossUnavailableSwitch);
    const bossUnavailableProducts = yield select(getBossUnavailableProduct);
    const isLoyaltyTieringEnabled = yield select(getIsLoyaltyTieringEnabled);
    const skipCacheUpdate = bossUnavailableSwitch && bossUnavailableProducts?.length > 0;
    const actions = [];
    if (backPackProducts.length) {
      actions.push(
        call(removeItem, isLoyaltyTieringEnabled, backPackProducts, labels, unqualifiedItems)
      );
    }
    const unqualifiedItemsIdArray = JSON.parse(JSON.stringify(unqualifiedItemsIds));
    actions.push(
      call(removeItem, isLoyaltyTieringEnabled, unqualifiedItemsIdArray, labels, unqualifiedItems)
    );
    const resp = yield all(actions);
    const { deleteItemResp = {}, isLoyaltyBenefitsCacheUpdate = false } = resp[resp.length - 1];
    yield call(processMutationCachedDataSaga, {
      payload: {
        respToProcess: deleteItemResp,
        skipCache: skipCacheUpdate || false,
        isLoyaltyBenefitsCacheUpdate,
      },
    });
  }
  const isBackPackAloneError = yield select(getIsBackPackAloneError);
  yield put(BAG_PAGE_ACTIONS.closeCheckoutConfirmationModal());
  if (!isBackPackAloneError) {
    yield call(checkoutCart, true, navigation, closeModal, navigationActions, true);
  }
  yield put(setLoaderState(false));
}

export function* addItemToSFL({
  payload: {
    itemId,
    catEntryId,
    afterHandler,
    isMiniBag,
    price,
    afterSuccessCallback,
    wasPrice,
  } = {},
} = {}) {
  if (isMiniBag) {
    yield put(setSectionLoaderState({ miniBagLoaderState: true, section: 'minibag' }));
  } else {
    yield put(setLoaderState(true));
  }
  yield put(CHECKOUT_ACTIONS.setServerErrorCheckout({}));
  const isRememberedUser = yield select(isRemembered);
  const isRegistered = yield select(getUserLoggedInState);
  const countryCurrency = yield select(BAG_SELECTORS.getCurrentCurrency);
  const orderItemsCartPage = yield select(BAG_SELECTORS.getOrderItems);
  const isCanadaSIte = isCanada();
  try {
    let sflId = '';
    if (isRegistered) {
      sflId = yield select(getSFLId);
    } else {
      sflId = yield select(BAG_SELECTORS.getSflListId);
    }
    const isMoveToSFL = false;
    yield put(removeCartItem({ itemId, price, isMoveToSFL }));
    if (!isMiniBag) {
      yield put(setLoaderState(false));
    }
    yield put(setApplePayCartLoadingState(true));
    const res = yield call(
      addItemToSflList,
      catEntryId,
      isRememberedUser,
      isRegistered,
      imageGenerator,
      countryCurrency,
      isCanadaSIte,
      sflId,
      orderItemsCartPage,
      wasPrice
    );
    yield put(BAG_PAGE_ACTIONS.setSflData(res?.items));
    if (afterHandler) {
      afterHandler();
    }
    if (res.errorResponse && res.errorMessage) {
      const resErr = res.errorMessage[Object.keys(res.errorMessage)[0]];
      yield put(BAG_PAGE_ACTIONS.setCartItemsSflError(resErr));
    } else {
      if (res.sflId && !isRegistered) {
        yield put(setSflId(res.sflId));
        setSessionStorage({ key: 'SFL_ID', value: JSON.stringify(res.sflId) });
        setValueInAsyncStorage('SFL_ID', JSON.stringify(res.sflId));
      }
      yield put(BAG_PAGE_ACTIONS.setCartItemsSFL(true));

      yield delay(BAGPAGE_CONSTANTS.ITEM_SFL_SUCCESS_MSG_TIMEOUT);
    }
    if (afterSuccessCallback) {
      afterSuccessCallback();
    }
  } catch (err) {
    yield put(setSectionLoaderState(false, 'minibag'));
    yield put(setLoaderState(false));
    const errorsMapping = yield select(BAG_SELECTORS.getErrorMapping);
    yield put(BAG_PAGE_ACTIONS.setCartItemsSflError(getServerErrorMessage(err, errorsMapping)));
  }
}

export function* getSflDataSaga() {
  try {
    let sflId = '';
    const isRegistered = yield select(getUserLoggedInState);
    yield put(hasSFLApiCallCompleted(false));
    if (isRegistered) {
      sflId = yield select(getSFLId);
    } else {
      sflId = yield select(BAG_SELECTORS.getSflListId);
      if (!sflId) {
        sflId = JSON.parse(getSessionStorage('SFL_ID'));
        if (!sflId) {
          sflId = JSON.parse(getLocalStorage('SFL_ID'));
        }
      }
    }
    const { res } = yield call(getSflItems, sflId, imageGenerator);
    yield put(hasSFLApiCallCompleted(true));
    yield put(BAG_PAGE_ACTIONS.setSflData(res));
  } catch (err) {
    yield put(BAG_PAGE_ACTIONS.setBagPageError(err));
    yield put(hasSFLApiCallCompleted(false));
  }
}

export function* setModifiedSflData(data) {
  try {
    if (yield call(shouldTranslate, true)) {
      const translatedProductInfo = yield call(getTranslatedProductInfo, data.payload);
      if (!translatedProductInfo.error) {
        createMatchObject(data.payload, translatedProductInfo);
      }
    }
    yield put(BAG_PAGE_ACTIONS.setTranslatedSflData(data.payload));
  } catch (err) {
    yield put(BAG_PAGE_ACTIONS.setBagPageError(err));
  }
}
export function* setSflItemUpdate(payload) {
  try {
    let sflId = '';
    const isRegistered = yield select(getUserLoggedInState);
    if (isRegistered) {
      sflId = yield select(getSFLId);
    } else {
      sflId = yield select(BAG_SELECTORS.getSflListId);
    }
    yield put(setCartLoadingState(true));
    const {
      payload: { oldSkuId, newSkuId, callBack },
    } = payload;
    const res = yield call(updateSflItem, oldSkuId, newSkuId, sflId, imageGenerator);
    if (callBack) {
      callBack();
    }
    yield put(setLoaderState(false));
    yield put(BAG_PAGE_ACTIONS.setSflData(res));
  } catch (err) {
    yield put(setLoaderState(false));
    yield put(BAG_PAGE_ACTIONS.setBagPageError(err));
  }
}

export function* startSflItemMoveToBag({ payload }) {
  try {
    const sflItemsList = yield select(BAG_SELECTORS.getsflItemsList);
    const sflItems = sflItemsList && JSON.parse(JSON.stringify(sflItemsList));
    const { miscInfo } = payload;
    const { accessories: accessoriesList } = miscInfo || {};
    const accessoriesIds = (accessoriesList && JSON.parse(JSON.stringify(accessoriesList))) || [];
    let accessories = [];
    if (sflItems && sflItems.length) {
      accessories = sflItems?.filter((item) => {
        const { skuInfo } = item || {};
        const { variantId } = skuInfo || {};
        return accessoriesIds?.indexOf(variantId) !== -1;
      });
    }

    yield put(setLoaderState(false));
    yield put(BAG_PAGE_ACTIONS.buttonSpinnerLoading(true));
    yield call(startSflItemDelete, { payload: { ...payload, fromMoveToBag: true } });
    const addToCartDataWeb = {
      ...payload,
      originPage: 'fromMoveToBag',
      fromMoveToBag: true,
      fromPage: 'cart',
      sflItems,
      accessories,
    };
    yield AddedtoBagDynamicStore();
    yield put(addToCartEcom(addToCartDataWeb));

    yield put(setLoaderState(false));
    yield put(BAG_PAGE_ACTIONS.setSflItemDeleted(true));
    yield delay(BAGPAGE_CONSTANTS.ITEM_SFL_SUCCESS_MSG_TIMEOUT);
    yield put(BAG_PAGE_ACTIONS.setSflItemDeleted(false));
  } catch (err) {
    yield put(BAG_PAGE_ACTIONS.buttonSpinnerLoading(false));
    yield put(setLoaderState(false));
    yield put(BAG_PAGE_ACTIONS.setCartItemsSflError(err));
  }
}

// eslint-disable-next-line sonarjs/cognitive-complexity
export function* addItemToSFLInChannel({
  payload: { itemId, catEntryId, afterHandler, price, afterSuccessCallback, wasPrice } = {},
} = {}) {
  yield put(setApplePayCartLoadingState(true));
  yield put(setCartLoadingState(true));
  yield put(CHECKOUT_ACTIONS.setServerErrorCheckout({}));
  if (afterHandler) {
    afterHandler();
  }
  const isRememberedUser = yield select(isRemembered);
  const isRegistered = yield select(getUserLoggedInState);
  const countryCurrency = yield select(BAG_SELECTORS.getCurrentCurrency);
  const orderItemsCartPage = yield select(BAG_SELECTORS.getOrderItems);
  const orderAccessorieItems = yield select(BAG_SELECTORS.getorderAccessorieItems);

  const isCanadaSIte = isCanada();
  const deletedProductInfo = { orderId: yield select(getCartOrderId), orderItems: [itemId] };
  yield put(BAG_PAGE_ACTIONS.removeDeletedItem(deletedProductInfo));
  try {
    let sflId = '';
    if (isRegistered) {
      sflId = yield select(getSFLId);
    } else {
      sflId = yield select(BAG_SELECTORS.getSflListId);
    }

    const isMoveToSFL = false;
    const isBagPack = isBagPackCall(catEntryId, orderAccessorieItems, orderItemsCartPage);
    if (!isBagPack) {
      yield call(removeCartItemSaga, { payload: { itemId, price, isMoveToSFL } });
    }
    const res = yield call(
      addItemToSflList,
      catEntryId,
      isRememberedUser,
      isRegistered,
      imageGenerator,
      countryCurrency,
      isCanadaSIte,
      sflId,
      orderItemsCartPage,
      orderAccessorieItems,
      wasPrice,
      price
    );
    yield put(BAG_PAGE_ACTIONS.setSflData(res?.items));
    if (res.errorResponse && res.errorMessage) {
      const resErr = res.errorMessage[Object.keys(res.errorMessage)[0]];
      yield put(BAG_PAGE_ACTIONS.setCartItemsSflError(resErr));
      yield put(BAG_PAGE_ACTIONS.addDeletedItemOnAPiFailure());
    } else {
      if (res.sflId && !isRegistered) {
        yield put(setSflId(res.sflId));
        setSessionStorage({ key: 'SFL_ID', value: JSON.stringify(res.sflId) });
        setLocalStorage({ key: 'SFL_ID', value: JSON.stringify(res.sflId) });
      }
      yield put(BAG_PAGE_ACTIONS.setCartItemsSFL(true));
      // this is calling GET_CART_ITEMS this is waht we have to do when doing SFL
      const cacheTTL = yield select(getCartCacheTTL);
      yield call(fetchCartCachedData, cacheTTL);

      if (isBagPack) {
        yield put(removeCartItem({ itemId, price, isMoveToSFL }));
      } else {
        const updatedOrderItems =
          orderItemsCartPage?.filter((cartItem) => {
            return cartItem.getIn(['productInfo', 'itemPartNumber']) !== catEntryId;
          }) || [];
        yield put(setAddedToBagDataLocal(updatedOrderItems));
      }
      yield put(BAG_PAGE_ACTIONS.clearNonCachedCartDataTTL());
      yield delay(BAGPAGE_CONSTANTS.ITEM_SFL_SUCCESS_MSG_TIMEOUT);
    }
    if (afterSuccessCallback) {
      afterSuccessCallback();
    }
    yield put(setCartLoadingState(false));
  } catch (err) {
    yield put(setCartLoadingState(false));
    const errorsMapping = yield select(BAG_SELECTORS.getErrorMapping);
    yield put(BAG_PAGE_ACTIONS.setCartItemsSflError(getServerErrorMessage(err, errorsMapping)));
    yield put(BAG_PAGE_ACTIONS.addDeletedItemOnAPiFailure());
  }
}

// export function* startSflItemMoveToBagInChannel({ payload }) {
//   const getsflItemsList = yield select(BAG_SELECTORS.getsflItemsList);
//   try {
//     yield put(setLoaderState(true));
//     const { itemId, multiPackItems = null } = payload;
//     const addToCartData = {
//       skuInfo: {
//         skuId: itemId,
//       },
//       quantity: 1,
//       fromMoveToBag: true,
//       multiPackItems,
//     };
//     const res1 = yield call(addToCartEcom, { payload: addToCartData });
//     if (res1?.errorResponse && res1?.errorMessage) {
//       const resErr = res1.errorMessage[Object.keys(res1.errorMessage)[0]];
//       yield put(BAG_PAGE_ACTIONS.setCartItemsSflError(resErr));
//       yield put(BAG_PAGE_ACTIONS.setCartItemsSflError(res1.errorMessage));
//     } else {
//       yield call(startSflItemDelete, { payload: { ...payload, fromMoveToBag: true } });

//       yield call(getCartDataSaga, {
//         payload: {
//           isRecalculateTaxes: true,
//           recalcRewards: true,
//           translation: true,
//           excludeCartItems: false,
//         },
//       });
//       yield put(setLoaderState(false));
//       yield put(BAG_PAGE_ACTIONS.setSflItemDeleted(true));
//       yield put(BAG_PAGE_ACTIONS.setSflItemMovedToBag(true));
//       yield delay(BAGPAGE_CONSTANTS.ITEM_SFL_SUCCESS_MSG_TIMEOUT);
//       yield put(BAG_PAGE_ACTIONS.setSflItemDeleted(false));
//     }
//   } catch (err) {
//     yield put(setLoaderState(false));
//     yield put(BAG_PAGE_ACTIONS.setCartItemsSflError(err));
//     yield put(BAG_PAGE_ACTIONS.setSflData(getsflItemsList));
//   }
// }

// export function* addProductsToBag() {
//   const addProductToBag = yield actionChannel(BAGPAGE_CONSTANTS.SFL_ITEMS_MOVE_TO_BAG);
//   while (true) {
//     try {
//       yield take(addProductToBag);
//       yield* startSflItemMoveToBagInChannel();
//     } catch (e) {
//       console.log(e);
//       break;
//     }
//   }
// }

export function* addProductsToSFL() {
  const saveProductForLater = yield actionChannel(BAGPAGE_CONSTANTS.ADD_ITEM_SAVE_FOR_LATER);
  while (true) {
    try {
      const payload = yield take(saveProductForLater);
      yield call(addItemToSFLInChannel, payload);
    } catch (e) {
      console.log(e);
      break;
    }
  }
}

const getUpdatedUrl = ({ url, cookieToken }) => {
  if (urlContainsQuery(url)) {
    return `${url}&ct=${cookieToken}`;
  }
  return `${url}?ct=${cookieToken}`;
};

const getActiveTabUrl = (url) => {
  const activeUrl = new URL(url);
  return `${window.location.protocol}//${window.location.host}/us/home/${activeUrl.search}`;
};
// TODO similiar to BrandTab.saga ,have to move in common core util saga.
export function* handleVMPNavigation({ payload }) {
  const { brandName = '', active, url, target = '_self' } = payload || {};
  try {
    if (!active) {
      const response = yield call(NavigateXHR, '', {}, brandName);
      const { encodedCookie = '' } = response && response.data;
      if (encodedCookie) {
        const Url = getUpdatedUrl({ url, cookieToken: encodedCookie });
        window.open(Url, target);
      }
    } else {
      const activeUrl = getActiveTabUrl(url);
      window.open(activeUrl, target);
    }
  } catch (err) {
    logger.error(err);
  }
}

function* calculateEstimatedTax({ payload: { zipcode } = {} } = {}) {
  yield put(BAG_PAGE_ACTIONS.setZipCodeError(null));
  const estimatedTaxReduxTTLValue = yield select(estimatedTaxReduxTTL);
  const newMsEstimatedTaxFlag = yield select(newMsEstimatedTax);
  const zipForTaxEstimation = yield select(BAG_SELECTORS.getZipForTaxEstimation);
  const orderType = yield select(getOrderType);
  const zipCode = zipcode || zipForTaxEstimation;
  const isDefaultShipping = yield select(getEstimatedTaxFromDefaultShipping);
  const isFromEstimatedTaxFormField = yield select(isFromEstimatedTaxFormFlag);
  const orderTypeValue =
    orderType === 'PURE_ECOM'
      ? 'ECOM'
      : orderType === 'PURE_BOSS'
      ? 'BOSS'
      : orderType === 'PURE_BOPIS'
      ? 'BOPIS'
      : 'MIX';
  const defaultShippingAddress = yield select(getPreferredAddress);
  let payload;
  if (newMsEstimatedTaxFlag) {
    const cartData = JSON.parse(JSON.stringify(yield select(BAG_SELECTORS.getOrderItems)));
    const lineItems = cartData.map((item) => {
      return {
        lineItemId: item?.productInfo.variant || '',
        partnumber: item?.productInfo.variantNo || '',
        quantity: item?.itemInfo.quantity || '',
        salesTaxCategory: item?.itemInfo.taxClassId || '',
        price: item?.itemInfo.price || '',
        discount: item.itemInfo.price - item.itemInfo.offerPrice || 0,
        lineItemType: item?.miscInfo.orderItemType || '',
        stlocId: item?.miscInfo.storeId || null,
      };
    });

    let taxPayload;
    if (isDefaultShipping) {
      taxPayload = {
        streetAddress1: defaultShippingAddress?.address1,
        streetAddress2: defaultShippingAddress?.address2 || '',
        city: defaultShippingAddress?.city,
        state: defaultShippingAddress?.stateCode,
        zipCode: defaultShippingAddress?.postalCode,
        country: isCanada() ? 'CA' : 'US',
      };
    } else {
      taxPayload = {
        streetAddress1: '',
        streetAddress2: '',
        city: '',
        state: '',
        zipCode: zipcode,
        country: isCanada() ? 'CA' : 'US',
      };
    }
    payload = {
      lineItems,
      shippingAddress: taxPayload,
      orderType: orderTypeValue,
    };
  }
  try {
    const res = yield call(
      fetchEstimatedTax,
      payload,
      newMsEstimatedTaxFlag,
      zipCode,
      orderTypeValue,
      isDefaultShipping
    );
    const { data } = res;
    if (data || data === 0) {
      yield put(BAG_PAGE_ACTIONS.setEstimatedTax({ tax: data, estimatedTaxReduxTTLValue }));
      setSessionStorage({ key: 'estimatedTax', value: JSON.stringify(data) });
    }
  } catch (err) {
    yield put(BAG_PAGE_ACTIONS.setEstimatedTax({ tax: 0, estimatedTaxReduxTTLValue }));
  } finally {
    yield put(setLoaderState(false));
    yield put(resetTaxFromDefaultAddress(false));
    yield put(BAG_PAGE_ACTIONS.isFromEstimatedTaxForm(false));
    if (isFromEstimatedTaxFormField) {
      yield put(BAG_PAGE_ACTIONS.setZipForTaxEstimation({ zipcode, estimatedTaxReduxTTLValue }));
    }
  }
}

export const getBackPackExist = (orderItems = []) => {
  try {
    if (orderItems && orderItems.size) {
      return orderItems.some((item) => {
        return (
          item?.getIn(['miscInfo', 'c_accessories']) || item?.getIn(['miscInfo', 'c_mainProducts'])
        );
      });
    }
    return false;
  } catch (e) {
    return false;
  }
};

const getDefaultError = (error, errorMapping) => {
  return (
    (error && error.errorCodes && errorMapping[error.errorCodes]) ||
    (errorMapping && errorMapping.DEFAULT)
  );
};

function* saveShareCartSaga() {
  const errorMapping = yield select(BAG_SELECTORS.getErrorMapping);
  try {
    yield put(saveShareCartErr(null));
    const emailId = yield select(getUserEmail);
    const orderItems = yield select(BAG_SELECTORS.getOrderItems);
    const isBackPack = getBackPackExist(orderItems);

    const res = yield call(saveShareCart, emailId, isBackPack.toString(), errorMapping);
    if (res && res.reqId) {
      const analyticsUtm =
        '?cid=sms-_-sharecart-_-bagpagesharecart-_-sharecartsmstext-_-&utm_medium=sms&utm_source=sharecart&utm_campaign=bagpagesharecart&utm_content=sharecartsmstext';
      const requestUrl = `${window.location.origin}/${getSiteId()}/sharecart/${res.reqId}`;
      const smsLabelCopy = getDynamicLabelValues('dynamic.cart.lbl_share_cart_sms_copy');
      const brandId = getBrand();
      const smsBody = smsLabelCopy.replace('#brandId', BRAND_NAMES[brandId]);
      window.open(`sms:?&body=${smsBody}${requestUrl}${analyticsUtm}`, '_self');
    }
  } catch (error) {
    const errorMessage =
      error?.errorCodes === 'ERR_MAX_SAVE_SHARE_CART_REACHED'
        ? {
            isMaxShareReached: true,
            errorMessage: errorMapping[error.errorCodes],
          }
        : {
            errorMessage: error?.errorCodes
              ? errorMapping[error.errorCodes]
              : errorMapping?.ERR_FAILED_SAVE_SHARE_CART,
          };
    yield put(saveShareCartErr(errorMessage));
  }
}

function* fetchShareCartSaga({ payload }) {
  const errorMapping = yield select(BAG_SELECTORS.getErrorMapping);
  try {
    const { refid } = payload;
    yield put(fetchShareCartErr(null));
    const res = yield call(fetchShareCart, refid, errorMapping);
    if (res && res.reqId) {
      const cacheTTL = yield select(getCartCacheTTL);
      yield call(fetchCartCachedData, cacheTTL, true);
      routerPush('/bag', '/bag');
    }
  } catch (error) {
    const errorMessage = getDefaultError(error, errorMapping);
    yield put(fetchShareCartErr(errorMessage));
  }
}

export function* BagPageSaga() {
  const cachedCartData = validateReduxCache(getCachedCartDataSaga);
  const nonCachedCartData = validateReduxCache(getNonCachedCartDataSaga);
  yield takeLatest(BAGPAGE_CONSTANTS.GET_ORDER_DETAILS, getOrderDetailSaga);
  yield takeLatest(BAGPAGE_CONSTANTS.GET_CART_DATA, getCartDataSaga);
  yield takeLatest(BAGPAGE_CONSTANTS.GET_CACHED_CART_DATA, cachedCartData);
  yield takeLatest(BAGPAGE_CONSTANTS.GET_NON_CACHED_CART_DATA, nonCachedCartData);
  yield takeLatest(BAGPAGE_CONSTANTS.GET_CART_DATA_SEQUENTIALLY, getCartDataSequentially);
  yield takeLatest(BAGPAGE_CONSTANTS.PROCESS_MUTATION_CACHED_DATA, processMutationCachedDataSaga);
  yield takeLatest(
    BAGPAGE_CONSTANTS.PROCESS_MUTATION_NON_CACHED_DATA,
    processMutationNonCachedDataSaga
  );
  yield takeLatest(BAGPAGE_CONSTANTS.VMP_NAVIGATION_XHR, handleVMPNavigation);
  yield takeLatest(BAGPAGE_CONSTANTS.FETCH_MODULEX_CONTENT, fetchModuleX);
  yield takeLatest(
    BAGPAGE_CONSTANTS.REMOVE_UNQUALIFIED_AND_CHECKOUT,
    removeUnqualifiedItemsAndCheckout
  );
  yield takeLatest(BAGPAGE_CONSTANTS.FETCH_INVENTORY_DETAILS, makeInventoryCallSaga);
  yield takeLatest(BAGPAGE_CONSTANTS.ROUTE_FOR_CART_CHECKOUT, routeForCartCheckout);
  yield takeLatest(BAGPAGE_CONSTANTS.START_BAG_CHECKOUT, startCartCheckout);
  yield takeLatest(BAGPAGE_CONSTANTS.START_PLCC_CHECKOUT, startPlccCheckout);
  yield takeLatest(BAGPAGE_CONSTANTS.START_PAYPAL_CHECKOUT, startPaypalCheckout);
  yield takeLatest(BAGPAGE_CONSTANTS.START_APPLE_PAY_CHECKOUT, startApplePayCheckout);
  yield takeLatest(BAGPAGE_CONSTANTS.START_AFTERPAY_EXPRESS_CHECKOUT, startAfterPayExpressCheckout);
  yield takeLatest(BAGPAGE_CONSTANTS.AUTHORIZATION_PAYPAL_CHECKOUT, authorizePayPalPayment);
  yield takeLatest(BAGPAGE_CONSTANTS.GET_SFL_DATA, getSflDataSaga);
  yield takeLatest(BAGPAGE_CONSTANTS.SFL_ITEMS_DELETE, startSflItemDelete);
  yield takeLatest(BAGPAGE_CONSTANTS.SFL_ITEMS_MOVE_TO_BAG, startSflItemMoveToBag);
  yield takeLatest(BAGPAGE_CONSTANTS.START_PAYPAL_NATIVE_CHECKOUT, startPaypalNativeCheckout);
  yield takeLatest(BAGPAGE_CONSTANTS.SET_SFL_DATA, setModifiedSflData);
  yield takeLatest(BAGPAGE_CONSTANTS.UPDATE_SFL_ITEM, setSflItemUpdate);
  yield takeLatest(BAGPAGE_CONSTANTS.GET_UNQUALIFIED_ITEMS, getUnqualifiedItemsCall);
  yield takeLatest(
    BAGPAGE_CONSTANTS.OPEN_APAY_UNQUALIFIED_ITEMS_MODAL,
    openApayUnqualifiedItemModal
  );
  const cachedTaxtData = validateReduxCache(calculateEstimatedTax);
  yield takeLatest(BAGPAGE_CONSTANTS.GET_ESTIMATED_TAX, cachedTaxtData);
  yield takeLatest(BAGPAGE_CONSTANTS.RESET_CART_CACHE, resetCartCache);

  yield takeLatest(BAGPAGE_CONSTANTS.ADD_ITEM_SAVE_FOR_LATER, addItemToSFLInChannel);
  yield takeLatest(BAGPAGE_CONSTANTS.SAVE_SHARE_CART, saveShareCartSaga);
  yield takeLatest(BAGPAGE_CONSTANTS.FETCH_SHARE_CART, fetchShareCartSaga);
}

export default BagPageSaga;
